var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticStyle: { display: "flex", "flex-direction": "row-reverse" },
      attrs: { id: "content-area" },
    },
    [
      _c("div", { staticClass: "button-flex" }, [
        _c("div", { staticClass: "button-area1" }, [
          _c(
            "div",
            {
              staticClass: "button-box1",
              on: {
                click: function ($event) {
                  return _vm.handleDown()
                },
              },
            },
            [_vm._v("打印")]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "button-area2" }, [
          _c(
            "div",
            {
              staticClass: "button-box2",
              on: {
                click: function ($event) {
                  return _vm.returnBack()
                },
              },
            },
            [_vm._v("返回")]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "demo-area" }, [
        _c(
          "div",
          { style: { height: _vm.Dheight }, attrs: { id: "demo" } },
          [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading,
                    expression: "loading",
                  },
                ],
                staticClass: "page-module",
                attrs: {
                  "element-loading-text": "加速生成中",
                  "element-loading-spinner": "el-icon-loading",
                  "element-loading-background": "rgba(0, 0, 0, 0.8)",
                },
              },
              [
                _c("div", { staticClass: "page-area" }, [
                  _c("div", { staticClass: "top-area" }, [
                    _c("div", { staticClass: "top-left-area" }, [
                      _c("span", { staticClass: "top-left-area-title" }, [
                        _vm._v("中国基金公司量化数据报告 "),
                      ]),
                      _c("span", { staticClass: "line-area" }, [_vm._v("|")]),
                      _c("span", { staticClass: "top-left-area-date" }, [
                        _vm._v(
                          "\n                                " +
                            _vm._s(_vm.companyReportData.quarterStr)
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _vm._m(0),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "title-head-area" }, [
                    _c("div", { staticClass: "title-head-left" }, [
                      _c("div", { staticClass: "title-head-company-name" }, [
                        _vm._v(
                          "\n                                " +
                            _vm._s(_vm.companyData.companyNameCN) +
                            "\n                            "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "title-head-date" }, [
                        _c("span", [_vm._v("成⽴时间：")]),
                        _c("span", [
                          _vm._v(_vm._s(_vm.companyReportData.companyDate)),
                        ]),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "content-main1-area" }, [
                    _c("div", { staticClass: "content-main1-left" }, [
                      _c("div", { staticClass: "content-left-box-area" }, [
                        _c("div", { staticClass: "content-left-top-area" }, [
                          _c("span", {
                            staticClass: "teamImgClass",
                            domProps: { innerHTML: _vm._s(_vm.TDGLlogo) },
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "desc-text1" }, [
                            _vm._v("管理团队"),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "content-left-bottom-area1" },
                          [
                            _vm._m(1),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  flex: "1",
                                  "align-items": "center",
                                  "justify-content": "space-between",
                                },
                              },
                              [
                                _vm._m(2),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      flex: "1",
                                      "font-weight": "400",
                                      "font-size": "14px",
                                      color: "black",
                                      "justify-content": "flex-end",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.companyData.managerCount == ""
                                          ? "--"
                                          : _vm.companyData.managerCount
                                      )
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      flex: "1",
                                      "font-size": "14px",
                                      color: "black",
                                      "justify-content": "flex-end",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.companyData.managerCountRank == ""
                                          ? "--"
                                          : _vm.companyData.managerCountRank
                                      )
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          "font-weight": "200",
                                          "font-size": "15px",
                                          color: "rgb(161 161 161)",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.companyData.managerCountRank ==
                                              ""
                                              ? ""
                                              : "/"
                                          ) +
                                            _vm._s(
                                              _vm.companyData
                                                .managerCountRank == ""
                                                ? ""
                                                : _vm.companyReportData
                                                    .managerCountRankSize
                                            )
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  flex: "1",
                                  "align-items": "center",
                                  "justify-content": "space-between",
                                },
                              },
                              [
                                _vm._m(3),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      flex: "1",
                                      "font-weight": "400",
                                      "font-size": "14px",
                                      color: "black",
                                      "justify-content": "flex-end",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.companyData.managerCareerTime == ""
                                          ? "--"
                                          : parseFloat(
                                              _vm.companyData.managerCareerTime
                                            ).toFixed(2)
                                      )
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      flex: "1",
                                      "font-size": "14px",
                                      color: "black",
                                      "justify-content": "flex-end",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.companyData.managerCareerTimeRank ==
                                          ""
                                          ? "--"
                                          : _vm.companyData
                                              .managerCareerTimeRank
                                      )
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          "font-weight": "200",
                                          "font-size": "15px",
                                          color: "rgb(161 161 161)",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.companyData
                                              .managerCareerTimeRank == ""
                                              ? ""
                                              : "/"
                                          ) +
                                            _vm._s(
                                              _vm.companyData
                                                .managerCareerTimeRank == ""
                                                ? ""
                                                : _vm.companyReportData
                                                    .managerCareerTimeRankSize
                                            )
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  flex: "1",
                                  "align-items": "center",
                                  "justify-content": "space-between",
                                },
                              },
                              [
                                _vm._m(4),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      flex: "1",
                                      "font-weight": "400",
                                      "font-size": "14px",
                                      color: "black",
                                      "justify-content": "flex-end",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.companyData.managerStayTime == ""
                                          ? "--"
                                          : parseFloat(
                                              _vm.companyData.managerStayTime
                                            ).toFixed(2)
                                      )
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      flex: "1",
                                      "font-size": "14px",
                                      color: "black",
                                      "justify-content": "flex-end",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.companyData.managerStayTimeRank ==
                                          ""
                                          ? "--"
                                          : _vm.companyData.managerStayTimeRank
                                      )
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          "font-weight": "200",
                                          "font-size": "15px",
                                          color: "rgb(161 161 161)",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.companyData
                                              .managerStayTimeRank == ""
                                              ? ""
                                              : "/"
                                          ) +
                                            _vm._s(
                                              _vm.companyData
                                                .managerStayTimeRank == ""
                                                ? ""
                                                : _vm.companyReportData
                                                    .managerStayTimeRankSize
                                            )
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  flex: "1",
                                  "align-items": "center",
                                  "justify-content": "space-between",
                                },
                              },
                              [
                                _vm._m(5),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      flex: "1",
                                      "font-weight": "400",
                                      "font-size": "14px",
                                      color: "black",
                                      "justify-content": "flex-end",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.companyData.retention_3Y == ""
                                          ? "--"
                                          : parseFloat(
                                              _vm.companyData.retention_3Y
                                            ).toFixed(2) + "%"
                                      )
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      flex: "1",
                                      "font-size": "14px",
                                      color: "black",
                                      "justify-content": "flex-end",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.companyData.retentionRank_3Y == ""
                                          ? "--"
                                          : _vm.companyData.retentionRank_3Y
                                      )
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          "font-weight": "200",
                                          "font-size": "15px",
                                          color: "rgb(161 161 161)",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.companyData.retentionRank_3Y ==
                                              ""
                                              ? ""
                                              : "/"
                                          ) +
                                            _vm._s(
                                              _vm.companyData
                                                .retentionRank_3Y == ""
                                                ? ""
                                                : _vm.companyReportData
                                                    .retentionRank3YSize
                                            )
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "content-left-box-area" }, [
                        _c("div", { staticClass: "content-left-top-area" }, [
                          _c("span", {
                            staticClass: "levelImgClass",
                            domProps: { innerHTML: _vm._s(_vm.MSlogo) },
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "desc-text" }, [
                            _vm._v("综合评级"),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "content-left-bottom-area2" },
                          [
                            _vm.starNumBlack == "1" ||
                            _vm.starNumBlack == "2" ||
                            _vm.starNumBlack == "3" ||
                            _vm.starNumBlack == "4" ||
                            _vm.starNumBlack == "5"
                              ? _c(
                                  "div",
                                  { staticClass: "left-bottom-area1" },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "bottom-text",
                                        staticStyle: {
                                          color: "black",
                                          "font-size": "13px",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                            排名\n                                        "
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              : _c("div", [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "null-node-area",
                                      staticStyle: {
                                        "margin-bottom": "0px",
                                        "margin-top": "10px",
                                        "align-self": "end",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                            暂无信息\n                                        "
                                      ),
                                    ]
                                  ),
                                ]),
                            _vm._v(" "),
                            _vm.starNumBlack == "1" ||
                            _vm.starNumBlack == "2" ||
                            _vm.starNumBlack == "3" ||
                            _vm.starNumBlack == "4" ||
                            _vm.starNumBlack == "5"
                              ? _c(
                                  "div",
                                  { staticClass: "left-bottom-area2" },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          "font-size": "13px",
                                          "font-weight": "550",
                                          flex: "1",
                                          color: "black",
                                        },
                                      },
                                      [_vm._v("加权星级")]
                                    ),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "star-area" }, [
                                      _vm.starNumBlack == "1"
                                        ? _c(
                                            "div",
                                            {
                                              staticStyle: { display: "flex" },
                                            },
                                            [
                                              _c("span", {
                                                staticClass: "companyStarClass",
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.companyStar
                                                  ),
                                                },
                                              }),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.starNumBlack == "2"
                                        ? _c(
                                            "div",
                                            {
                                              staticStyle: { display: "flex" },
                                            },
                                            [
                                              _c("span", {
                                                staticClass: "companyStarClass",
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.companyStar
                                                  ),
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("span", {
                                                staticClass: "companyStarClass",
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.companyStar
                                                  ),
                                                },
                                              }),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.starNumBlack == "3"
                                        ? _c(
                                            "div",
                                            {
                                              staticStyle: { display: "flex" },
                                            },
                                            [
                                              _c("span", {
                                                staticClass: "companyStarClass",
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.companyStar
                                                  ),
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("span", {
                                                staticClass: "companyStarClass",
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.companyStar
                                                  ),
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("span", {
                                                staticClass: "companyStarClass",
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.companyStar
                                                  ),
                                                },
                                              }),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.starNumBlack == "4"
                                        ? _c(
                                            "div",
                                            {
                                              staticStyle: { display: "flex" },
                                            },
                                            [
                                              _c("span", {
                                                staticClass: "companyStarClass",
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.companyStar
                                                  ),
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("span", {
                                                staticClass: "companyStarClass",
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.companyStar
                                                  ),
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("span", {
                                                staticClass: "companyStarClass",
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.companyStar
                                                  ),
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("span", {
                                                staticClass: "companyStarClass",
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.companyStar
                                                  ),
                                                },
                                              }),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.starNumBlack == "5"
                                        ? _c(
                                            "div",
                                            {
                                              staticStyle: { display: "flex" },
                                            },
                                            [
                                              _c("span", {
                                                staticClass: "companyStarClass",
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.companyStar
                                                  ),
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("span", {
                                                staticClass: "companyStarClass",
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.companyStar
                                                  ),
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("span", {
                                                staticClass: "companyStarClass",
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.companyStar
                                                  ),
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("span", {
                                                staticClass: "companyStarClass",
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.companyStar
                                                  ),
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("span", {
                                                staticClass: "companyStarClass",
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.companyStar
                                                  ),
                                                },
                                              }),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.showStarQuarter1,
                                              expression: "showStarQuarter1",
                                            },
                                          ],
                                          staticStyle: { display: "flex" },
                                        },
                                        [
                                          _c("span", {
                                            staticClass: "companyStarMarkClass",
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.companyStarMark
                                              ),
                                            },
                                          }),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.showStarQuarter2,
                                              expression: "showStarQuarter2",
                                            },
                                          ],
                                          staticStyle: { display: "flex" },
                                        },
                                        [
                                          _c("span", {
                                            staticClass: "companyStarClass2",
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.companyStar2
                                              ),
                                            },
                                          }),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.showStarQuarter4,
                                              expression: "showStarQuarter4",
                                            },
                                          ],
                                          staticStyle: { display: "flex" },
                                        },
                                        [
                                          _c("span", {
                                            staticClass: "companyStarClass4",
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.companyStar4
                                              ),
                                            },
                                          }),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _vm.showNumWhite == "5"
                                        ? _c(
                                            "div",
                                            {
                                              staticStyle: { display: "flex" },
                                            },
                                            [
                                              _c("span", {
                                                staticClass:
                                                  "companyStarWhiteClass",
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.companyStarWhite
                                                  ),
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("span", {
                                                staticClass:
                                                  "companyStarWhiteClass",
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.companyStarWhite
                                                  ),
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("span", {
                                                staticClass:
                                                  "companyStarWhiteClass",
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.companyStarWhite
                                                  ),
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("span", {
                                                staticClass:
                                                  "companyStarWhiteClass",
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.companyStarWhite
                                                  ),
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("span", {
                                                staticClass:
                                                  "companyStarWhiteClass",
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.companyStarWhite
                                                  ),
                                                },
                                              }),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.showNumWhite == "4"
                                        ? _c(
                                            "div",
                                            {
                                              staticStyle: { display: "flex" },
                                            },
                                            [
                                              _c("span", {
                                                staticClass:
                                                  "companyStarWhiteClass",
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.companyStarWhite
                                                  ),
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("span", {
                                                staticClass:
                                                  "companyStarWhiteClass",
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.companyStarWhite
                                                  ),
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("span", {
                                                staticClass:
                                                  "companyStarWhiteClass",
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.companyStarWhite
                                                  ),
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("span", {
                                                staticClass:
                                                  "companyStarWhiteClass",
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.companyStarWhite
                                                  ),
                                                },
                                              }),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.showNumWhite == "3"
                                        ? _c(
                                            "div",
                                            {
                                              staticStyle: { display: "flex" },
                                            },
                                            [
                                              _c("span", {
                                                staticClass:
                                                  "companyStarWhiteClass",
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.companyStarWhite
                                                  ),
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("span", {
                                                staticClass:
                                                  "companyStarWhiteClass",
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.companyStarWhite
                                                  ),
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("span", {
                                                staticClass:
                                                  "companyStarWhiteClass",
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.companyStarWhite
                                                  ),
                                                },
                                              }),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.showNumWhite == "2"
                                        ? _c(
                                            "div",
                                            {
                                              staticStyle: { display: "flex" },
                                            },
                                            [
                                              _c("span", {
                                                staticClass:
                                                  "companyStarWhiteClass",
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.companyStarWhite
                                                  ),
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c("span", {
                                                staticClass:
                                                  "companyStarWhiteClass",
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.companyStarWhite
                                                  ),
                                                },
                                              }),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.showNumWhite == "1"
                                        ? _c(
                                            "div",
                                            {
                                              staticStyle: { display: "flex" },
                                            },
                                            [
                                              _c("span", {
                                                staticClass:
                                                  "companyStarWhiteClass",
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.companyStarWhite
                                                  ),
                                                },
                                              }),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          "font-size": "14px",
                                          flex: "1",
                                          color: "black",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.companyData.aumweightedStar ==
                                              ""
                                              ? "--"
                                              : _vm.companyData.aumweightedStar
                                          )
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          "font-size": "14px",
                                          color: "black",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.companyReportData
                                              .aumWeightStarRank == ""
                                              ? "--"
                                              : _vm.companyReportData
                                                  .aumWeightStarRank
                                          )
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              "font-weight": "200",
                                              "font-size": "14px",
                                              color: "rgb(161 161 161)",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.companyReportData
                                                  .aumWeightStarRank == ""
                                                  ? ""
                                                  : "/"
                                              ) +
                                                _vm._s(
                                                  _vm.companyReportData
                                                    .aumWeightStarRank == ""
                                                    ? ""
                                                    : _vm.companyReportData
                                                        .aumWeightStarRankAll
                                                )
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              : _c("div", { staticClass: "left-bottom-area2" }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  height: "120px",
                                },
                              },
                              [
                                _vm.companyData.star5Per != "" ||
                                _vm.companyData.star4Per != "" ||
                                _vm.companyData.star3Per != "" ||
                                _vm.companyData.star2Per != "" ||
                                _vm.companyData.star1Per != ""
                                  ? _c(
                                      "div",
                                      { staticClass: "left-bottom-area33" },
                                      [_vm._m(6)]
                                    )
                                  : _c("div", {
                                      staticClass: "left-bottom-area33",
                                    }),
                                _vm._v(" "),
                                _vm.companyData.star5Per != "" ||
                                _vm.companyData.star4Per != "" ||
                                _vm.companyData.star3Per != "" ||
                                _vm.companyData.star2Per != "" ||
                                _vm.companyData.star1Per != ""
                                  ? _c(
                                      "div",
                                      { staticClass: "left-bottom-area3" },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "bottom-box1" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "box-top" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "black-box-area",
                                                  },
                                                  [
                                                    _c("div", {
                                                      class: [
                                                        _vm.companyData
                                                          .star5Per == ""
                                                          ? "black-null"
                                                          : "black-box5",
                                                      ],
                                                      style: {
                                                        height: _vm.height5,
                                                      },
                                                    }),
                                                    _vm._v(" "),
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.companyData
                                                            .star5Per == ""
                                                            ? "--"
                                                            : _vm.companyData
                                                                .star5Per
                                                        ) + "%"
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _vm._m(7),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "box-bottom-num" },
                                              [
                                                _vm._v(
                                                  "\n                                                    " +
                                                    _vm._s(
                                                      _vm.companyData
                                                        .star5Count == ""
                                                        ? "--"
                                                        : _vm.companyData
                                                            .star5Count
                                                    ) +
                                                    "\n                                                "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("div", {
                                          staticClass: "bottom-space",
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "bottom-box1" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "box-top" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "black-box-area",
                                                  },
                                                  [
                                                    _c("div", {
                                                      class: [
                                                        _vm.companyData
                                                          .star4Per == ""
                                                          ? "black-null"
                                                          : "black-box4",
                                                      ],
                                                      style: {
                                                        height: _vm.height4,
                                                      },
                                                    }),
                                                    _vm._v(" "),
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.companyData
                                                            .star4Per == ""
                                                            ? "--"
                                                            : _vm.companyData
                                                                .star4Per
                                                        ) + "%"
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _vm._m(8),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "box-bottom-num" },
                                              [
                                                _vm._v(
                                                  "\n                                                    " +
                                                    _vm._s(
                                                      _vm.companyData
                                                        .star4Count == ""
                                                        ? "--"
                                                        : _vm.companyData
                                                            .star4Count
                                                    ) +
                                                    "\n                                                "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("div", {
                                          staticClass: "bottom-space",
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "bottom-box1" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "box-top" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "black-box-area",
                                                  },
                                                  [
                                                    _c("div", {
                                                      class: [
                                                        _vm.companyData
                                                          .star3Per == ""
                                                          ? "black-null"
                                                          : "black-box3",
                                                      ],
                                                      style: {
                                                        height: _vm.height3,
                                                      },
                                                    }),
                                                    _vm._v(" "),
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.companyData
                                                            .star3Per == ""
                                                            ? "--"
                                                            : _vm.companyData
                                                                .star3Per
                                                        ) + "%"
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _vm._m(9),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "box-bottom-num" },
                                              [
                                                _vm._v(
                                                  "\n                                                    " +
                                                    _vm._s(
                                                      _vm.companyData
                                                        .star3Count == ""
                                                        ? "--"
                                                        : _vm.companyData
                                                            .star3Count
                                                    ) +
                                                    "\n                                                "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("div", {
                                          staticClass: "bottom-space",
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "bottom-box1" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "box-top" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "black-box-area",
                                                  },
                                                  [
                                                    _c("div", {
                                                      class: [
                                                        _vm.companyData
                                                          .star2Per == ""
                                                          ? "black-null"
                                                          : "black-box2",
                                                      ],
                                                      style: {
                                                        height: _vm.height2,
                                                      },
                                                    }),
                                                    _vm._v(" "),
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.companyData
                                                            .star2Per == ""
                                                            ? "--"
                                                            : _vm.companyData
                                                                .star2Per
                                                        ) + "%"
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _vm._m(10),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "box-bottom-num" },
                                              [
                                                _vm._v(
                                                  "\n                                                    " +
                                                    _vm._s(
                                                      _vm.companyData
                                                        .star2Count == ""
                                                        ? "--"
                                                        : _vm.companyData
                                                            .star2Count
                                                    ) +
                                                    "\n                                                "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("div", {
                                          staticClass: "bottom-space",
                                        }),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "bottom-box1" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "box-top" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "black-box-area",
                                                  },
                                                  [
                                                    _c("div", {
                                                      class: [
                                                        _vm.companyData
                                                          .star1Per == ""
                                                          ? "black-null"
                                                          : "black-box1",
                                                      ],
                                                      style: {
                                                        height: _vm.height1,
                                                      },
                                                    }),
                                                    _vm._v(" "),
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.companyData
                                                            .star1Per == ""
                                                            ? "--"
                                                            : _vm.companyData
                                                                .star1Per
                                                        ) + "%"
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _vm._m(11),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "box-bottom-num" },
                                              [
                                                _vm._v(
                                                  "\n                                                    " +
                                                    _vm._s(
                                                      _vm.companyData
                                                        .star1Count == ""
                                                        ? "--"
                                                        : _vm.companyData
                                                            .star1Count
                                                    ) +
                                                    "\n                                                "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _c("div", {
                                      staticClass: "left-bottom-area3",
                                    }),
                              ]
                            ),
                          ]
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "content-main1-right" }, [
                      _c("div", { staticClass: "content-desc-text" }, [
                        _vm._v(
                          "\n                                　　" +
                            _vm._s(_vm.companyReportData.shortName) +
                            "成立于" +
                            _vm._s(_vm.companyReportData.companyEstablishDate) +
                            "年，\n                                "
                        ),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.cityShow,
                                expression: "cityShow",
                              },
                            ],
                          },
                          [
                            _vm._v(
                              "注册地位于" +
                                _vm._s(_vm.companyReportData.province) +
                                _vm._s(_vm.companyReportData.city) +
                                _vm._s(
                                  _vm.gdShow || _vm.ywShow == true ? "，" : "。"
                                )
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.gdShow,
                                expression: "gdShow",
                              },
                            ],
                          },
                          [
                            _vm._v(
                              "主要股东为" + _vm._s(_vm.contentInfoData) + " 。"
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.ywShow,
                                expression: "ywShow",
                              },
                            ],
                          },
                          [
                            _vm._v("该公司"),
                            _c(
                              "span",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.tsShow,
                                    expression: "tsShow",
                                  },
                                ],
                              },
                              [_vm._v("同时")]
                            ),
                            _vm._v(
                              "拥有" +
                                _vm._s(_vm.attributeData) +
                                "等业务资格。"
                            ),
                          ]
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                                　　截止" +
                            _vm._s(_vm.companyReportData.latestDate) +
                            "，\n                                "
                        ),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.gmShow,
                                expression: "gmShow",
                              },
                            ],
                          },
                          [
                            _vm._v(
                              "公司管理公募基金（不含货币基金）规模为人民币" +
                                _vm._s(
                                  _vm.companyData.fundSize > 1
                                    ? Math.abs(
                                        parseFloat(
                                          _vm.companyData.fundSize
                                        ).toFixed(0)
                                      )
                                    : "不足1"
                                ) +
                                "亿元" +
                                _vm._s(
                                  _vm.zj3ytbShow ||
                                    _vm.cpxShow ||
                                    _vm.zj3yrShow ||
                                    _vm.zj3yShow ||
                                    _vm.zj1ytbShow ||
                                    _vm.zj1yrShow ||
                                    _vm.zj1yShow ||
                                    _vm.gmrShow == true
                                    ? "，"
                                    : "。"
                                )
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.gmrShow,
                                expression: "gmrShow",
                              },
                            ],
                          },
                          [
                            _vm._v(
                              "在" +
                                _vm._s(_vm.companyReportData.fundSizeRankSize) +
                                "家公司中位列第" +
                                _vm._s(_vm.companyData.fundSizeRank) +
                                "。"
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.zj1yShow,
                                expression: "zj1yShow",
                              },
                            ],
                          },
                          [
                            _vm._v(
                              "最近一年资金" +
                                _vm._s(_vm.fundSize1YText) +
                                _vm._s(
                                  Math.abs(
                                    parseFloat(
                                      _vm.companyData.fundSizeFlow_1Y
                                    ).toFixed(0)
                                  )
                                ) +
                                "亿元" +
                                _vm._s(
                                  _vm.zj3ytbShow ||
                                    _vm.cpxShow ||
                                    _vm.zj3yrShow ||
                                    _vm.zj3yShow ||
                                    _vm.zj1ytbShow ||
                                    _vm.zj1yrShow == true
                                    ? "，"
                                    : "。"
                                )
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.zj1yrShow,
                                expression: "zj1yrShow",
                              },
                            ],
                          },
                          [
                            _vm._v(
                              "排名" +
                                _vm._s(_vm.companyData.fundSizeFlowRank_1Y) +
                                "/" +
                                _vm._s(
                                  _vm.companyReportData.fundSizeFlowRank1YSize
                                ) +
                                _vm._s(
                                  _vm.zj3ytbShow ||
                                    _vm.cpxShow ||
                                    _vm.zj3yrShow ||
                                    _vm.zj3yShow ||
                                    _vm.zj1ytbShow == true
                                    ? "，"
                                    : "。"
                                )
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.zj1ytbShow,
                                expression: "zj1ytbShow",
                              },
                            ],
                          },
                          [
                            _vm._v(
                              "同比" +
                                _vm._s(_vm.raiseOrDown1Y) +
                                _vm._s(
                                  Math.abs(_vm.companyData.fundSizeFlowPer_1Y)
                                ) +
                                "%" +
                                _vm._s(
                                  _vm.zj3ytbShow ||
                                    _vm.cpxShow ||
                                    _vm.zj3yrShow ||
                                    _vm.zj3yShow == true
                                    ? "，"
                                    : "。"
                                )
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.zj3yShow,
                                expression: "zj3yShow",
                              },
                            ],
                          },
                          [
                            _vm._v(
                              "最近三年资金" +
                                _vm._s(_vm.fundSize3YText) +
                                _vm._s(
                                  Math.abs(
                                    parseFloat(
                                      _vm.companyData.fundSizeFlow_3Y
                                    ).toFixed(0)
                                  )
                                ) +
                                "亿元" +
                                _vm._s(
                                  _vm.zj3ytbShow ||
                                    _vm.cpxShow ||
                                    _vm.zj3yrShow == true
                                    ? "，"
                                    : "。"
                                )
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.zj3yrShow,
                                expression: "zj3yrShow",
                              },
                            ],
                          },
                          [
                            _vm._v(
                              "排名" +
                                _vm._s(_vm.companyData.fundSizeFlowRank_3Y) +
                                "/" +
                                _vm._s(
                                  _vm.companyReportData.fundSizeFlowRank3YSize
                                ) +
                                _vm._s(
                                  _vm.zj3ytbShow || _vm.cpxShow == true
                                    ? "，"
                                    : "。"
                                )
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.zj3ytbShow,
                                expression: "zj3ytbShow",
                              },
                            ],
                          },
                          [
                            _vm._v(
                              "同比" +
                                _vm._s(_vm.raiseOrDown3Y) +
                                _vm._s(
                                  Math.abs(_vm.companyData.fundSizeFlowPer_3Y)
                                ) +
                                "%。"
                            ),
                          ]
                        ),
                        _c("br"),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.cpxShow,
                                expression: "cpxShow",
                              },
                            ],
                          },
                          [
                            _vm._v(
                              "　　公司产品线覆盖" +
                                _vm._s(_vm.companyReportData.productionData) +
                                "类型。"
                            ),
                          ]
                        ),
                        _vm._v(
                          "\n                                截止" +
                            _vm._s(_vm.companyReportData.latestDate) +
                            "，\n                                "
                        ),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.zhpjShow,
                                expression: "zhpjShow",
                              },
                            ],
                          },
                          [
                            _vm._v(
                              "旗下基金规模加权后的晨星综合星级为" +
                                _vm._s(_vm.companyData.aumweightedStar) +
                                _vm._s(
                                  _vm.zhpjbjShow || _vm.zhpjrShow == true
                                    ? "，"
                                    : "。"
                                )
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.zhpjrShow,
                                expression: "zhpjrShow",
                              },
                            ],
                          },
                          [
                            _vm._v(
                              "排名" +
                                _vm._s(
                                  _vm.companyReportData.aumWeightStarRank
                                ) +
                                "/" +
                                _vm._s(
                                  _vm.companyReportData.aumWeightStarRankAll
                                ) +
                                _vm._s(_vm.zhpjbjShow == true ? "，" : "。")
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.zhpjbjShow,
                                expression: "zhpjbjShow",
                              },
                            ],
                          },
                          [
                            _vm._v(
                              "较上一期" +
                                _vm._s(_vm.companyReportData.compareStarStr) +
                                " 。"
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.zdcpShow,
                                expression: "zdcpShow",
                              },
                            ],
                          },
                          [
                            _vm._v(
                              "整体来看旗下主动管理产品业绩排名在" +
                                _vm._s(_vm.typeSum1) +
                                "个综合类" +
                                _vm._s(
                                  _vm.companyData.sizeType == 1
                                    ? "大型"
                                    : _vm.companyData.sizeType == 2
                                    ? "中型"
                                    : "小型"
                                ) +
                                "公司中排名第" +
                                _vm._s(_vm.companyData.companyScoreRawRank) +
                                _vm._s(
                                  _vm.gscpShow ||
                                    _vm.flShow ||
                                    _vm.pgcpShow == true
                                    ? "，"
                                    : "。"
                                )
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.pgcpShow,
                                expression: "pgcpShow",
                              },
                            ],
                          },
                          [
                            _vm._v(
                              "偏股型主动管理业绩评分在" +
                                _vm._s(_vm.typeSum2) +
                                "个偏股类" +
                                _vm._s(
                                  _vm.companyData.eqallocsizeType == 1
                                    ? "大型"
                                    : _vm.companyData.eqallocsizeType == 2
                                    ? "中型"
                                    : "小型"
                                ) +
                                "公司中排名第" +
                                _vm._s(
                                  _vm.companyData.eqalloccompanyScoreRawRank
                                ) +
                                _vm._s(
                                  _vm.gscpShow || _vm.flShow == true
                                    ? "，"
                                    : "。"
                                )
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.gscpShow,
                                expression: "gscpShow",
                              },
                            ],
                          },
                          [
                            _vm._v(
                              "固收型主动管理业绩在" +
                                _vm._s(_vm.typeSum3) +
                                "个固收类" +
                                _vm._s(
                                  _vm.companyData.fxincsizeType == 1
                                    ? "大型"
                                    : _vm.companyData.fxincsizeType == 2
                                    ? "中型"
                                    : "小型"
                                ) +
                                "公司中排名第" +
                                _vm._s(
                                  _vm.companyData.fxinccompanyScoreRawRank
                                ) +
                                " 。"
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.flShow,
                                expression: "flShow",
                              },
                            ],
                          },
                          [
                            _vm._v(
                              "旗下基金整体运营费率较同业" +
                                _vm._s(_vm.terscoreText) +
                                " 。"
                            ),
                          ]
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                                　　截止" +
                            _vm._s(_vm.companyReportData.yearStr) +
                            "，\n                                "
                        ),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.jlrsShow,
                                expression: "jlrsShow",
                              },
                            ],
                          },
                          [
                            _vm._v(
                              "公司在职基金经理为" +
                                _vm._s(_vm.companyData.managerCount) +
                                "人" +
                                _vm._s(
                                  _vm.wdxShow ||
                                    _vm.jsnlzlShow ||
                                    _vm.jjpmShow ||
                                    _vm.glnxShow == true
                                    ? "，"
                                    : "。"
                                )
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.glnxShow,
                                expression: "glnxShow",
                              },
                            ],
                          },
                          [
                            _vm._v(
                              "平均投资管理期限为" +
                                _vm._s(
                                  parseFloat(
                                    _vm.companyData.managerCareerTime
                                  ).toFixed(2)
                                ) +
                                "年" +
                                _vm._s(
                                  _vm.wdxShow ||
                                    _vm.jsnlzlShow ||
                                    _vm.jjpmShow == true
                                    ? "，"
                                    : "。"
                                )
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.jjpmShow,
                                expression: "jjpmShow",
                              },
                            ],
                          },
                          [
                            _vm._v(
                              "排名" +
                                _vm._s(_vm.companyData.managerCareerTimeRank) +
                                "/" +
                                _vm._s(
                                  _vm.companyReportData
                                    .managerCareerTimeRankSize
                                ) +
                                _vm._s(
                                  _vm.wdxShow || _vm.jsnlzlShow == true
                                    ? "，"
                                    : "。"
                                )
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.jsnlzlShow,
                                expression: "jsnlzlShow",
                              },
                            ],
                          },
                          [
                            _vm._v(
                              "近三年留职率为" +
                                _vm._s(
                                  parseFloat(
                                    _vm.companyData.retention_3Y
                                  ).toFixed(2)
                                ) +
                                "%" +
                                _vm._s(_vm.wdxShow == true ? "，" : "。")
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.wdxShow,
                                expression: "wdxShow",
                              },
                            ],
                          },
                          [
                            _vm._v(
                              "任职稳定性" +
                                _vm._s(_vm.comfortableText) +
                                "行业中位数。"
                            ),
                          ]
                        ),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "content-main2-area" }, [
                    _c("div", { staticClass: "content-main2-right" }, [
                      _c("div", { staticClass: "box-right1" }, [
                        _c("div", { staticClass: "content-left-top-area1" }, [
                          _c("span", {
                            staticClass: "yjpfImgClass",
                            domProps: { innerHTML: _vm._s(_vm.YJPFlogo) },
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "desc-text6" }, [
                            _vm._v("业绩评分"),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "content-big-box1" }, [
                          _c("div", { staticClass: "content-bottom-area" }, [
                            _vm._m(12),
                            _vm._v(" "),
                            _vm.companyData.classCount == "" &&
                            _vm.companyData.eqallocclassCount == "" &&
                            _vm.companyData.fxincclassCount == ""
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "top-box-area1",
                                    staticStyle: {
                                      "align-items": "flex-start",
                                      "justify-content": "left",
                                      "font-weight": "normal",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "null-node-area",
                                        staticStyle: {
                                          "margin-bottom": "0px",
                                          "margin-top": "10px",
                                          "align-self": "flex-start",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                                暂无信息\n                                            "
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.companyData.classCount != ""
                              ? _c("div", { staticClass: "top-box-area2" }, [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        flex: "0.5",
                                        "text-align": "left",
                                      },
                                    },
                                    [_vm._v("综合")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        flex: "0.5",
                                        "text-align": "center",
                                        color: "black",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                                " +
                                          _vm._s(
                                            _vm.companyData.classCount == ""
                                              ? "--"
                                              : _vm.companyData.classCount
                                          ) +
                                          "\n                                            "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        flex: "0.5",
                                        "text-align": "center",
                                        color: "black",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                                " +
                                          _vm._s(
                                            _vm.companyData.sizeType == 1
                                              ? "大型"
                                              : _vm.companyData.sizeType == 2
                                              ? "中型"
                                              : "小型"
                                          )
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.companyData.sizeType == 1
                                    ? _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            flex: "0.5",
                                            "text-align": "center",
                                            color: "black",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.companyData
                                                .companyScoreRawRank == ""
                                                ? "--"
                                                : _vm.companyData
                                                    .companyScoreRawRank
                                            )
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                "font-weight": "200",
                                                color: "rgb(161 161 161)",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.companyData
                                                    .companyScoreRawRank == ""
                                                    ? ""
                                                    : "/"
                                                ) +
                                                  _vm._s(
                                                    _vm.companyData
                                                      .companyScoreRawRank == ""
                                                      ? ""
                                                      : _vm.companyData
                                                          .allBigSum
                                                  )
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm.companyData.sizeType == 2
                                    ? _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            flex: "0.5",
                                            "text-align": "center",
                                            color: "black",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                                " +
                                              _vm._s(
                                                _vm.companyData
                                                  .companyScoreRawRank == ""
                                                  ? "--"
                                                  : _vm.companyData
                                                      .companyScoreRawRank
                                              )
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                "font-weight": "200",
                                                color: "rgb(161 161 161)",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.companyData
                                                    .companyScoreRawRank == ""
                                                    ? ""
                                                    : "/"
                                                ) +
                                                  _vm._s(
                                                    _vm.companyData
                                                      .companyScoreRawRank == ""
                                                      ? ""
                                                      : _vm.companyData
                                                          .allMiddleSum
                                                  )
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm.companyData.sizeType == 3
                                    ? _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            flex: "0.5",
                                            "text-align": "center",
                                            color: "black",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                                " +
                                              _vm._s(
                                                _vm.companyData
                                                  .companyScoreRawRank == ""
                                                  ? "--"
                                                  : _vm.companyData
                                                      .companyScoreRawRank
                                              )
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                "font-weight": "200",
                                                color: "rgb(161 161 161)",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.companyData
                                                    .companyScoreRawRank == ""
                                                    ? ""
                                                    : "/"
                                                ) +
                                                  _vm._s(
                                                    _vm.companyData
                                                      .companyScoreRawRank == ""
                                                      ? ""
                                                      : _vm.companyData
                                                          .allSmallSum
                                                  )
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            flex: "0.5",
                                            "text-align": "center",
                                            color: "black",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                                " +
                                              _vm._s(
                                                _vm.companyData
                                                  .companyScoreRawRank == ""
                                                  ? "--"
                                                  : _vm.companyData
                                                      .companyScoreRawRank
                                              )
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                "font-weight": "200",
                                                color: "rgb(161 161 161)",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.companyData
                                                    .companyScoreRawRank == ""
                                                    ? ""
                                                    : "/"
                                                ) +
                                                  _vm._s(
                                                    _vm.companyData
                                                      .companyScoreRawRank == ""
                                                      ? ""
                                                      : _vm.companyData
                                                          .allSmallSum
                                                  )
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "top-process-area" },
                                    [
                                      _c("div", { staticClass: "every-box" }),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "every-box" }),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "every-box" }),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "every-box" }),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "every-box" }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "top-size-area" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "top-size-box1" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  style: {
                                                    "margin-left": _vm.num1,
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                                            " +
                                                      _vm._s(
                                                        _vm.companyData
                                                          .companyScoreRaw == ""
                                                          ? "--"
                                                          : _vm.companyData
                                                              .companyScoreRaw
                                                      )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "top-size-box2",
                                              style: {
                                                "margin-left": _vm.progressNum1,
                                                width: _vm.progressWidth1,
                                              },
                                            },
                                            [
                                              _c("div", {
                                                staticClass: "middle-num-box",
                                                style: { left: _vm.middleNum1 },
                                              }),
                                              _vm._v(" "),
                                              _c("div", {
                                                staticClass: "score-num-box",
                                                style: { left: _vm.scoreNum1 },
                                              }),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ])
                              : _c("div", { staticClass: "top-box-area2" }),
                            _vm._v(" "),
                            _vm.companyData.eqallocclassCount != ""
                              ? _c("div", { staticClass: "top-box-area2" }, [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        flex: "0.5",
                                        "text-align": "left",
                                      },
                                    },
                                    [_vm._v("偏股")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        flex: "0.5",
                                        "text-align": "center",
                                        color: "black",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                                " +
                                          _vm._s(
                                            _vm.companyData.eqallocclassCount ==
                                              ""
                                              ? "--"
                                              : _vm.companyData
                                                  .eqallocclassCount
                                          )
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        flex: "0.5",
                                        "text-align": "center",
                                        color: "black",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                                " +
                                          _vm._s(
                                            _vm.companyData.eqallocsizeType == 1
                                              ? "大型"
                                              : _vm.companyData
                                                  .eqallocsizeType == 2
                                              ? "中型"
                                              : "小型"
                                          )
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.companyData.eqallocsizeType == 1
                                    ? _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            flex: "0.5",
                                            "text-align": "center",
                                            color: "black",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                                " +
                                              _vm._s(
                                                _vm.companyData
                                                  .eqalloccompanyScoreRawRank ==
                                                  ""
                                                  ? "--"
                                                  : _vm.companyData
                                                      .eqalloccompanyScoreRawRank
                                              )
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                "font-weight": "200",
                                                color: "rgb(161 161 161)",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.companyData
                                                    .eqalloccompanyScoreRawRank ==
                                                    ""
                                                    ? ""
                                                    : "/"
                                                ) +
                                                  _vm._s(
                                                    _vm.companyData
                                                      .eqalloccompanyScoreRawRank ==
                                                      ""
                                                      ? ""
                                                      : _vm.companyData
                                                          .eqallocbigSum
                                                  )
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm.companyData.eqallocsizeType == 2
                                    ? _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            flex: "0.5",
                                            "text-align": "center",
                                            color: "black",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                                " +
                                              _vm._s(
                                                _vm.companyData
                                                  .eqalloccompanyScoreRawRank ==
                                                  ""
                                                  ? "--"
                                                  : _vm.companyData
                                                      .eqalloccompanyScoreRawRank
                                              )
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                "font-weight": "200",
                                                color: "rgb(161 161 161)",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.companyData
                                                    .eqalloccompanyScoreRawRank ==
                                                    ""
                                                    ? ""
                                                    : "/"
                                                ) +
                                                  _vm._s(
                                                    _vm.companyData
                                                      .eqalloccompanyScoreRawRank ==
                                                      ""
                                                      ? ""
                                                      : _vm.companyData
                                                          .eqallocmiddleSum
                                                  )
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm.companyData.eqallocsizeType == 3
                                    ? _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            flex: "0.5",
                                            "text-align": "center",
                                            color: "black",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                                " +
                                              _vm._s(
                                                _vm.companyData
                                                  .eqalloccompanyScoreRawRank ==
                                                  ""
                                                  ? "--"
                                                  : _vm.companyData
                                                      .eqalloccompanyScoreRawRank
                                              )
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                "font-weight": "200",
                                                color: "rgb(161 161 161)",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.companyData
                                                    .eqalloccompanyScoreRawRank ==
                                                    ""
                                                    ? ""
                                                    : "/"
                                                ) +
                                                  _vm._s(
                                                    _vm.companyData
                                                      .eqalloccompanyScoreRawRank ==
                                                      ""
                                                      ? ""
                                                      : _vm.companyData
                                                          .eqallocsmallSum
                                                  )
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            flex: "0.5",
                                            "text-align": "center",
                                            color: "black",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                                " +
                                              _vm._s(
                                                _vm.companyData
                                                  .eqalloccompanyScoreRawRank ==
                                                  ""
                                                  ? "--"
                                                  : _vm.companyData
                                                      .eqalloccompanyScoreRawRank
                                              )
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                "font-weight": "200",
                                                color: "rgb(161 161 161)",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.companyData
                                                    .eqalloccompanyScoreRawRank ==
                                                    ""
                                                    ? ""
                                                    : "/"
                                                ) +
                                                  _vm._s(
                                                    _vm.companyData
                                                      .eqalloccompanyScoreRawRank ==
                                                      ""
                                                      ? ""
                                                      : _vm.companyData
                                                          .eqallocsmallSum
                                                  )
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "top-process-area" },
                                    [
                                      _c("div", { staticClass: "every-box" }),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "every-box" }),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "every-box" }),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "every-box" }),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "every-box" }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "top-size-area" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "top-size-box1" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  style: {
                                                    "margin-left": _vm.num2,
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                                            " +
                                                      _vm._s(
                                                        _vm.companyData
                                                          .eqalloccompanyScoreRaw ==
                                                          ""
                                                          ? "--"
                                                          : _vm.companyData
                                                              .eqalloccompanyScoreRaw
                                                      )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "top-size-box2",
                                              style: {
                                                "margin-left": _vm.progressNum2,
                                                width: _vm.progressWidth2,
                                              },
                                            },
                                            [
                                              _c("div", {
                                                staticClass: "middle-num-box",
                                                style: { left: _vm.middleNum2 },
                                              }),
                                              _vm._v(" "),
                                              _c("div", {
                                                staticClass: "score-num-box",
                                                style: { left: _vm.scoreNum2 },
                                              }),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ])
                              : _c("div", { staticClass: "top-box-area2" }),
                            _vm._v(" "),
                            _vm.companyData.fxincclassCount != ""
                              ? _c("div", { staticClass: "top-box-area2" }, [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        flex: "0.5",
                                        "text-align": "left",
                                      },
                                    },
                                    [_vm._v("固收")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        flex: "0.5",
                                        "text-align": "center",
                                        color: "black",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                                " +
                                          _vm._s(
                                            _vm.companyData.fxincclassCount ==
                                              ""
                                              ? "--"
                                              : _vm.companyData.fxincclassCount
                                          )
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        flex: "0.5",
                                        "text-align": "center",
                                        color: "black",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                                " +
                                          _vm._s(
                                            _vm.companyData.fxincsizeType == 1
                                              ? "大型"
                                              : _vm.companyData.fxincsizeType ==
                                                2
                                              ? "中型"
                                              : "小型"
                                          )
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.companyData.fxincsizeType == 1
                                    ? _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            flex: "0.5",
                                            "text-align": "center",
                                            color: "black",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                                " +
                                              _vm._s(
                                                _vm.companyData
                                                  .fxinccompanyScoreRawRank ==
                                                  ""
                                                  ? "--"
                                                  : _vm.companyData
                                                      .fxinccompanyScoreRawRank
                                              )
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                "font-weight": "200",
                                                color: "rgb(161 161 161)",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.companyData
                                                    .fxinccompanyScoreRawRank ==
                                                    ""
                                                    ? ""
                                                    : "/"
                                                ) +
                                                  _vm._s(
                                                    _vm.companyData
                                                      .fxinccompanyScoreRawRank ==
                                                      ""
                                                      ? ""
                                                      : _vm.companyData
                                                          .fxincbigSum
                                                  )
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm.companyData.fxincsizeType == 2
                                    ? _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            flex: "0.5",
                                            "text-align": "center",
                                            color: "black",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                                " +
                                              _vm._s(
                                                _vm.companyData
                                                  .fxinccompanyScoreRawRank ==
                                                  ""
                                                  ? "--"
                                                  : _vm.companyData
                                                      .fxinccompanyScoreRawRank
                                              )
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                "font-weight": "200",
                                                color: "rgb(161 161 161)",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.companyData
                                                    .fxinccompanyScoreRawRank ==
                                                    ""
                                                    ? ""
                                                    : "/"
                                                ) +
                                                  _vm._s(
                                                    _vm.companyData
                                                      .fxinccompanyScoreRawRank ==
                                                      ""
                                                      ? ""
                                                      : _vm.companyData
                                                          .fxincmiddleSum
                                                  )
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm.companyData.fxincsizeType == 3
                                    ? _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            flex: "0.5",
                                            "text-align": "center",
                                            color: "black",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                                " +
                                              _vm._s(
                                                _vm.companyData
                                                  .fxinccompanyScoreRawRank ==
                                                  ""
                                                  ? "--"
                                                  : _vm.companyData
                                                      .fxinccompanyScoreRawRank
                                              )
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                "font-weight": "200",
                                                color: "rgb(161 161 161)",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.companyData
                                                    .fxinccompanyScoreRawRank ==
                                                    ""
                                                    ? ""
                                                    : "/"
                                                ) +
                                                  _vm._s(
                                                    _vm.companyData
                                                      .fxinccompanyScoreRawRank ==
                                                      ""
                                                      ? ""
                                                      : _vm.companyData
                                                          .fxincsmallSum
                                                  )
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            flex: "0.5",
                                            "text-align": "center",
                                            color: "black",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                                " +
                                              _vm._s(
                                                _vm.companyData
                                                  .fxinccompanyScoreRawRank ==
                                                  ""
                                                  ? "--"
                                                  : _vm.companyData
                                                      .fxinccompanyScoreRawRank
                                              )
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                "font-weight": "200",
                                                color: "rgb(161 161 161)",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.companyData
                                                    .fxinccompanyScoreRawRank ==
                                                    ""
                                                    ? ""
                                                    : "/"
                                                ) +
                                                  _vm._s(
                                                    _vm.companyData
                                                      .fxinccompanyScoreRawRank ==
                                                      ""
                                                      ? ""
                                                      : _vm.companyData
                                                          .fxincsmallSum
                                                  )
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "top-process-area" },
                                    [
                                      _c("div", { staticClass: "every-box" }),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "every-box" }),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "every-box" }),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "every-box" }),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "every-box" }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "top-size-area" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "top-size-box1" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  style: {
                                                    "margin-left": _vm.num3,
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                                            " +
                                                      _vm._s(
                                                        _vm.companyData
                                                          .fxinccompanyScoreRaw ==
                                                          ""
                                                          ? "--"
                                                          : _vm.companyData
                                                              .fxinccompanyScoreRaw
                                                      )
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "top-size-box2",
                                              style: {
                                                "margin-left": _vm.progressNum3,
                                                width: _vm.progressWidth3,
                                              },
                                            },
                                            [
                                              _c("div", {
                                                staticClass: "middle-num-box",
                                                style: { left: _vm.middleNum3 },
                                              }),
                                              _vm._v(" "),
                                              _c("div", {
                                                staticClass: "score-num-box",
                                                style: { left: _vm.scoreNum3 },
                                              }),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ])
                              : _c("div", { staticClass: "top-box-area2" }),
                            _vm._v(" "),
                            _vm.companyData.classCount != "" ||
                            _vm.companyData.eqallocclassCount != "" ||
                            _vm.companyData.fxincclassCount != ""
                              ? _c("div", { staticClass: "num-mark-area" }, [
                                  _vm._m(13),
                                ])
                              : _c("div", { staticClass: "num-mark-area" }),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "box-right2",
                          style: { height: _vm.flexRatioHeight },
                        },
                        [
                          _c("div", { staticClass: "xc-area" }, [
                            _c("div", { staticClass: "xc-box" }, [
                              _vm._m(14),
                              _vm._v(" "),
                              _vm.survivalRatio[0] != "0" ||
                              _vm.successRatio[0] != "0" ||
                              _vm.survivalRatio[1] != "0" ||
                              _vm.successRatio[1] != "0" ||
                              _vm.survivalRatio[2] != "0" ||
                              _vm.successRatio[2] != "0"
                                ? _c("div", { staticClass: "xc-bottom-box" }, [
                                    _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value:
                                              _vm.survivalRatio[0] != "0" ||
                                              _vm.successRatio[0] != "0",
                                            expression:
                                              "survivalRatio[0] != '0' || successRatio[0] != '0'",
                                          },
                                        ],
                                        staticClass: "bottom-row",
                                      },
                                      [
                                        _vm._m(15),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "top-right" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "top-three",
                                                staticStyle: {
                                                  display: "flex",
                                                  flex: "1.6",
                                                  color: "black",
                                                  "justify-content": "flex-end",
                                                },
                                              },
                                              [
                                                _vm.survivalRatio[0] >
                                                _vm.survivalAvg[0]
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          color: "#960000",
                                                          "font-size": "15px",
                                                          "font-feature-settings":
                                                            "normal",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            parseFloat(
                                                              _vm
                                                                .survivalRatio[0]
                                                            ).toFixed(2)
                                                          ) + "% "
                                                        ),
                                                      ]
                                                    )
                                                  : _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          color: "#518428",
                                                          "font-size": "15px",
                                                          "font-feature-settings":
                                                            "normal",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            parseFloat(
                                                              _vm
                                                                .survivalRatio[0]
                                                            ).toFixed(2)
                                                          ) + "% "
                                                        ),
                                                      ]
                                                    ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      color: "rgb(161 161 161)",
                                                      "font-size": "13px",
                                                      "font-feature-settings":
                                                        "normal",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "/ " +
                                                        _vm._s(
                                                          parseFloat(
                                                            _vm.survivalAvg[0]
                                                          ).toFixed(2)
                                                        ) +
                                                        "%"
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "top-five",
                                                staticStyle: {
                                                  display: "flex",
                                                  flex: "1",
                                                  "font-size": "14px",
                                                  color: "black",
                                                  "justify-content": "flex-end",
                                                },
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.survivalRank[0] ==
                                                        null
                                                        ? "-"
                                                        : _vm.survivalRank[0].substring(
                                                            0,
                                                            _vm.survivalRank[0].lastIndexOf(
                                                              "/"
                                                            )
                                                          )
                                                    )
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      color: "rgb(161 161 161)",
                                                      "font-weight": "200",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.survivalRank[0] ==
                                                          null
                                                          ? "-"
                                                          : _vm.survivalRank[0].substring(
                                                              _vm.survivalRank[0].lastIndexOf(
                                                                "/"
                                                              )
                                                            )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "top-ten",
                                                staticStyle: {
                                                  display: "flex",
                                                  flex: "2",
                                                  "font-size": "14px",
                                                  color: "black",
                                                  "justify-content": "flex-end",
                                                },
                                              },
                                              [
                                                _vm.successRatio[0] >
                                                _vm.successAvg[0]
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          color: "#960000",
                                                          "font-size": "15px",
                                                          "font-feature-settings":
                                                            "normal",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            parseFloat(
                                                              _vm
                                                                .successRatio[0]
                                                            ).toFixed(2)
                                                          ) + "% "
                                                        ),
                                                      ]
                                                    )
                                                  : _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          color: "#518428",
                                                          "font-size": "15px",
                                                          "font-feature-settings":
                                                            "normal",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            parseFloat(
                                                              _vm
                                                                .successRatio[0]
                                                            ).toFixed(2)
                                                          ) + "% "
                                                        ),
                                                      ]
                                                    ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      color: "rgb(161 161 161)",
                                                      "font-size": "13px",
                                                      "font-feature-settings":
                                                        "normal",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "/ " +
                                                        _vm._s(
                                                          parseFloat(
                                                            _vm.successAvg[0]
                                                          ).toFixed(2)
                                                        ) +
                                                        "%"
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "top-ten",
                                                staticStyle: {
                                                  display: "flex",
                                                  flex: "1",
                                                  "font-size": "14px",
                                                  color: "black",
                                                  "justify-content": "flex-end",
                                                },
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.successRank[0] == null
                                                        ? "-"
                                                        : _vm.successRank[0].substring(
                                                            0,
                                                            _vm.successRank[0].lastIndexOf(
                                                              "/"
                                                            )
                                                          )
                                                    )
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      color: "rgb(161 161 161)",
                                                      "font-weight": "200",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.successRank[0] ==
                                                          null
                                                          ? "-"
                                                          : _vm.successRank[0].substring(
                                                              _vm.successRank[0].lastIndexOf(
                                                                "/"
                                                              )
                                                            )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value:
                                              _vm.survivalRatio[1] != "0" ||
                                              _vm.successRatio[1] != "0",
                                            expression:
                                              "survivalRatio[1] != '0' || successRatio[1] != '0'",
                                          },
                                        ],
                                        staticClass: "bottom-row",
                                      },
                                      [
                                        _vm._m(16),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "top-right" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "top-three",
                                                staticStyle: {
                                                  display: "flex",
                                                  flex: "1.6",
                                                  "font-size": "14px",
                                                  color: "black",
                                                  "justify-content": "flex-end",
                                                },
                                              },
                                              [
                                                _vm.survivalRatio[1] >
                                                _vm.survivalAvg[1]
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          color: "#960000",
                                                          "font-size": "15px",
                                                          "font-feature-settings":
                                                            "normal",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            parseFloat(
                                                              _vm
                                                                .survivalRatio[1]
                                                            ).toFixed(2)
                                                          ) + "% "
                                                        ),
                                                      ]
                                                    )
                                                  : _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          color: "#518428",
                                                          "font-size": "15px",
                                                          "font-feature-settings":
                                                            "normal",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            parseFloat(
                                                              _vm
                                                                .survivalRatio[1]
                                                            ).toFixed(2)
                                                          ) + "% "
                                                        ),
                                                      ]
                                                    ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      color: "rgb(161 161 161)",
                                                      "font-size": "13px",
                                                      "font-feature-settings":
                                                        "normal",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "/ " +
                                                        _vm._s(
                                                          parseFloat(
                                                            _vm.survivalAvg[1]
                                                          ).toFixed(2)
                                                        ) +
                                                        "%"
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "top-five",
                                                staticStyle: {
                                                  display: "flex",
                                                  flex: "1",
                                                  "font-size": "14px",
                                                  color: "black",
                                                  "justify-content": "flex-end",
                                                },
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.survivalRank[1] ==
                                                        null
                                                        ? "--"
                                                        : _vm.survivalRank[1].substring(
                                                            0,
                                                            _vm.survivalRank[1].lastIndexOf(
                                                              "/"
                                                            )
                                                          )
                                                    )
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      color: "rgb(161 161 161)",
                                                      "font-weight": "200",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.survivalRank[1] ==
                                                          null
                                                          ? "-"
                                                          : _vm.survivalRank[1].substring(
                                                              _vm.survivalRank[1].lastIndexOf(
                                                                "/"
                                                              )
                                                            )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "top-ten",
                                                staticStyle: {
                                                  display: "flex",
                                                  flex: "2",
                                                  "font-size": "14px",
                                                  color: "black",
                                                  "justify-content": "flex-end",
                                                },
                                              },
                                              [
                                                _vm.successRatio[1] >
                                                _vm.successAvg[1]
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          color: "#960000",
                                                          "font-size": "15px",
                                                          "font-feature-settings":
                                                            "normal",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            parseFloat(
                                                              _vm
                                                                .successRatio[1]
                                                            ).toFixed(2)
                                                          ) + "% "
                                                        ),
                                                      ]
                                                    )
                                                  : _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          color: "#518428",
                                                          "font-size": "15px",
                                                          "font-feature-settings":
                                                            "normal",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            parseFloat(
                                                              _vm
                                                                .successRatio[1]
                                                            ).toFixed(2)
                                                          ) + "% "
                                                        ),
                                                      ]
                                                    ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      color: "rgb(161 161 161)",
                                                      "font-size": "13px",
                                                      "font-feature-settings":
                                                        "normal",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "/ " +
                                                        _vm._s(
                                                          parseFloat(
                                                            _vm.successAvg[1]
                                                          ).toFixed(2)
                                                        ) +
                                                        "%"
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "top-ten",
                                                staticStyle: {
                                                  display: "flex",
                                                  flex: "1",
                                                  "font-size": "14px",
                                                  color: "black",
                                                  "justify-content": "flex-end",
                                                },
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.successRank[1] == null
                                                        ? "--"
                                                        : _vm.successRank[1].substring(
                                                            0,
                                                            _vm.successRank[1].lastIndexOf(
                                                              "/"
                                                            )
                                                          )
                                                    )
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      color: "rgb(161 161 161)",
                                                      "font-weight": "200",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.successRank[1] ==
                                                          null
                                                          ? "-"
                                                          : _vm.successRank[1].substring(
                                                              _vm.successRank[1].lastIndexOf(
                                                                "/"
                                                              )
                                                            )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value:
                                              _vm.survivalRatio[2] != "0" ||
                                              _vm.successRatio[2] != "0",
                                            expression:
                                              "survivalRatio[2] != '0' || successRatio[2] != '0'",
                                          },
                                        ],
                                        staticClass: "bottom-row",
                                      },
                                      [
                                        _vm._m(17),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "top-right" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "top-three",
                                                staticStyle: {
                                                  display: "flex",
                                                  flex: "1.6",
                                                  "font-size": "14px",
                                                  color: "black",
                                                  "justify-content": "flex-end",
                                                },
                                              },
                                              [
                                                _vm.survivalRatio[2] >
                                                _vm.survivalAvg[2]
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          color: "#960000",
                                                          "font-size": "15px",
                                                          "font-feature-settings":
                                                            "normal",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            parseFloat(
                                                              _vm
                                                                .survivalRatio[2]
                                                            ).toFixed(2)
                                                          ) + "% "
                                                        ),
                                                      ]
                                                    )
                                                  : _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          color: "#518428",
                                                          "font-size": "15px",
                                                          "font-feature-settings":
                                                            "normal",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            parseFloat(
                                                              _vm
                                                                .survivalRatio[2]
                                                            ).toFixed(2)
                                                          ) + "% "
                                                        ),
                                                      ]
                                                    ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      color: "rgb(161 161 161)",
                                                      "font-size": "13px",
                                                      "font-feature-settings":
                                                        "normal",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "/ " +
                                                        _vm._s(
                                                          parseFloat(
                                                            _vm.survivalAvg[2]
                                                          ).toFixed(2)
                                                        ) +
                                                        "%"
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "top-five",
                                                staticStyle: {
                                                  display: "flex",
                                                  flex: "1",
                                                  "font-size": "14px",
                                                  color: "black",
                                                  "justify-content": "flex-end",
                                                },
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.survivalRank[2] ==
                                                        null
                                                        ? "--"
                                                        : _vm.survivalRank[2].substring(
                                                            0,
                                                            _vm.survivalRank[2].lastIndexOf(
                                                              "/"
                                                            )
                                                          )
                                                    )
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      color: "rgb(161 161 161)",
                                                      "font-weight": "200",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.survivalRank[2] ==
                                                          null
                                                          ? "--"
                                                          : _vm.survivalRank[2].substring(
                                                              _vm.survivalRank[2].lastIndexOf(
                                                                "/"
                                                              )
                                                            )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "top-ten",
                                                staticStyle: {
                                                  display: "flex",
                                                  flex: "2",
                                                  "font-size": "14px",
                                                  color: "black",
                                                  "justify-content": "flex-end",
                                                },
                                              },
                                              [
                                                _vm.successRatio[2] >
                                                _vm.successAvg[2]
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          color: "#960000",
                                                          "font-size": "15px",
                                                          "font-feature-settings":
                                                            "normal",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            parseFloat(
                                                              _vm
                                                                .successRatio[2]
                                                            ).toFixed(2)
                                                          ) + "% "
                                                        ),
                                                      ]
                                                    )
                                                  : _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          color: "#518428",
                                                          "font-size": "15px",
                                                          "font-feature-settings":
                                                            "normal",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            parseFloat(
                                                              _vm
                                                                .successRatio[2]
                                                            ).toFixed(2)
                                                          ) + "% "
                                                        ),
                                                      ]
                                                    ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      color: "rgb(161 161 161)",
                                                      "font-size": "13px",
                                                      "font-feature-settings":
                                                        "normal",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "/ " +
                                                        _vm._s(
                                                          parseFloat(
                                                            _vm.successAvg[2]
                                                          ).toFixed(2)
                                                        ) +
                                                        "%"
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "top-ten",
                                                staticStyle: {
                                                  display: "flex",
                                                  flex: "1",
                                                  "font-size": "14px",
                                                  color: "black",
                                                  "justify-content": "flex-end",
                                                },
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.successRank[2] == null
                                                        ? "--"
                                                        : _vm.successRank[2].substring(
                                                            0,
                                                            _vm.successRank[2].lastIndexOf(
                                                              "/"
                                                            )
                                                          )
                                                    )
                                                  ),
                                                ]),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      color: "rgb(161 161 161)",
                                                      "font-weight": "200",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.successRank[2] ==
                                                          null
                                                          ? "--"
                                                          : _vm.successRank[2].substring(
                                                              _vm.successRank[2].lastIndexOf(
                                                                "/"
                                                              )
                                                            )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ])
                                : _c("div", { staticClass: "xc-bottom-box" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "null-node-area",
                                        staticStyle: {
                                          "margin-bottom": "0px",
                                          "align-self": "flex-start",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                                暂无信息\n                                            "
                                        ),
                                      ]
                                    ),
                                  ]),
                            ]),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "box-right6" }, [
                        _c("div", { staticClass: "content-left-top-area1" }, [
                          _c("span", {
                            staticClass: "gmImgClass",
                            domProps: { innerHTML: _vm._s(_vm.GMlogo) },
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "desc-text3" }, [
                            _vm._v("规模"),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "gm-area2" }, [
                          _c("div", { staticClass: "gm-box" }, [
                            _vm._m(18),
                            _vm._v(" "),
                            _c("div", { staticClass: "gm-row" }, [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    flex: "3",
                                    "justify-content": "flex-start",
                                  },
                                },
                                [_vm._v("管理规模 (亿元)")]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    flex: "1",
                                    "justify-content": "flex-end",
                                    color: "black",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.companyData.fundSize == ""
                                        ? "--"
                                        : _vm.companyData.fundSize > 1
                                        ? parseFloat(
                                            _vm.companyData.fundSize
                                          ).toFixed(0)
                                        : "<1"
                                    )
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    flex: "1",
                                    "justify-content": "flex-end",
                                    color: "black",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.companyData.fundSizeRank == ""
                                        ? "--"
                                        : _vm.companyData.fundSizeRank
                                    )
                                  ),
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        "font-weight": "200",
                                        color: "rgb(161 161 161)",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "/" +
                                          _vm._s(
                                            _vm.companyReportData
                                              .fundSizeRankSize == ""
                                              ? "--"
                                              : _vm.companyReportData
                                                  .fundSizeRankSize
                                          )
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "gm-row" }, [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    flex: "3",
                                    "justify-content": "flex-start",
                                  },
                                },
                                [_vm._v("基金数量")]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    flex: "1",
                                    "justify-content": "flex-end",
                                    color: "black",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.companyIndexInfo
                                        .nonMoneyMarketFundCount == ""
                                        ? "--"
                                        : _vm.companyIndexInfo
                                            .nonMoneyMarketFundCount
                                    )
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    flex: "1",
                                    "justify-content": "flex-end",
                                    color: "black",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.nonMoneyMarketFundCountRank == ""
                                        ? "--"
                                        : _vm.nonMoneyMarketFundCountRank.substring(
                                            0,
                                            _vm.nonMoneyMarketFundCountRank.lastIndexOf(
                                              "/"
                                            )
                                          )
                                    )
                                  ),
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        color: "rgb(161 161 161)",
                                        "font-weight": "200",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.nonMoneyMarketFundCountRank == ""
                                            ? "-"
                                            : _vm.nonMoneyMarketFundCountRank.substring(
                                                _vm.nonMoneyMarketFundCountRank.lastIndexOf(
                                                  "/"
                                                )
                                              )
                                        )
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "gm-row" }, [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    flex: "3",
                                    "justify-content": "flex-start",
                                  },
                                },
                                [_vm._v("份额数量")]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    flex: "1",
                                    "justify-content": "flex-end",
                                    color: "black",
                                  },
                                },
                                [_vm._v(_vm._s(_vm.companyData.fundCount))]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    flex: "1",
                                    "justify-content": "flex-end",
                                    color: "black",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.companyData.fundCountRank == ""
                                        ? "--"
                                        : _vm.companyData.fundCountRank
                                    )
                                  ),
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        "font-weight": "200",
                                        color: "rgb(161 161 161)",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "/" +
                                          _vm._s(
                                            _vm.companyReportData
                                              .fundCountRankSize == ""
                                              ? "--"
                                              : _vm.companyReportData
                                                  .fundCountRankSize
                                          )
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]),
                          ]),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "content-main3-left-area" }, [
                      _c("div", { staticClass: "content-main3-left-box" }, [
                        _c(
                          "div",
                          {
                            staticClass: "box-left1",
                            style: {
                              height: _vm.cpxFlexHeight,
                              "border-bottom": _vm.cpxBorderBottom,
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "box-left1-top-area",
                                style: { "border-bottom": _vm.cpxBorderBottom },
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "content-left-top-area2" },
                                  [
                                    _c("span", {
                                      staticClass: "cpxImgClass",
                                      domProps: {
                                        innerHTML: _vm._s(_vm.CPXlogo),
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "desc-text7" }, [
                                      _vm._v("产品线"),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      width: "100%",
                                      height: "220px",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "cpx-left-area" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              width: "180px",
                                              height: "100%",
                                              display: "-webkit-flex",
                                              "align-items": "center",
                                            },
                                          },
                                          [
                                            _c("v-chart", {
                                              staticStyle: {
                                                width: "100%",
                                                height: "180px",
                                                left: "-15px",
                                              },
                                              attrs: {
                                                option: _vm.orgOptions,
                                                autoresize: "",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "cpx-right-area" },
                                      [
                                        _vm._m(19),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "cpx-data-row" },
                                          [
                                            _vm._m(20),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "cpx-row",
                                                staticStyle: {
                                                  display: "flex",
                                                  "border-bottom":
                                                    "1px solid #CBCBCB",
                                                },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      display: "flex",
                                                      flex: "1",
                                                    },
                                                  },
                                                  [_vm._v("股票")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      display: "flex",
                                                      flex: "1",
                                                      "font-weight": "400",
                                                      "justify-content":
                                                        "flex-end",
                                                      "margin-right": "14px",
                                                      color: "black",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        parseFloat(
                                                          _vm.companyData.equity
                                                        ) == "NaN"
                                                          ? "--"
                                                          : _vm.companyData
                                                              .equity > 1
                                                          ? parseFloat(
                                                              _vm.companyData
                                                                .equity
                                                            )
                                                          : "<1"
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      display: "flex",
                                                      flex: "1",
                                                      "justify-content":
                                                        "flex-end",
                                                      color: "black",
                                                    },
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.companyData
                                                            .equityrank == ""
                                                            ? "--"
                                                            : _vm.companyData
                                                                .equityrank
                                                        )
                                                      ),
                                                    ]),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          color:
                                                            "rgb(161 161 161)",
                                                          "font-weight": "200",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.companyData
                                                              .equityrank == ""
                                                              ? ""
                                                              : "/"
                                                          ) +
                                                            _vm._s(
                                                              _vm.companyData
                                                                .equityrank ==
                                                                ""
                                                                ? ""
                                                                : _vm
                                                                    .companyReportData
                                                                    .equityRankSize
                                                            )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "cpx-data-row" },
                                          [
                                            _vm._m(21),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "cpx-row",
                                                staticStyle: {
                                                  display: "flex",
                                                  "border-bottom":
                                                    "1px solid #CBCBCB",
                                                },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      display: "flex",
                                                      flex: "1",
                                                    },
                                                  },
                                                  [_vm._v("混合")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      display: "flex",
                                                      flex: "1",
                                                      "font-weight": "400",
                                                      "justify-content":
                                                        "flex-end",
                                                      "margin-right": "14px",
                                                      color: "black",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        parseFloat(
                                                          _vm.companyData.alloc
                                                        ) == "NaN"
                                                          ? "--"
                                                          : _vm.companyData
                                                              .alloc > 1
                                                          ? parseFloat(
                                                              _vm.companyData
                                                                .alloc
                                                            )
                                                          : "<1"
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      display: "flex",
                                                      flex: "1",
                                                      "justify-content":
                                                        "flex-end",
                                                      color: "black",
                                                    },
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.companyData
                                                            .allocrank == ""
                                                            ? "--"
                                                            : _vm.companyData
                                                                .allocrank
                                                        )
                                                      ),
                                                    ]),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          color:
                                                            "rgb(161 161 161)",
                                                          "font-weight": "200",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.companyData
                                                              .allocrank == ""
                                                              ? ""
                                                              : "/"
                                                          ) +
                                                            _vm._s(
                                                              _vm.companyData
                                                                .allocrank == ""
                                                                ? ""
                                                                : _vm
                                                                    .companyReportData
                                                                    .allocRankSize
                                                            )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "cpx-data-row" },
                                          [
                                            _vm._m(22),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "cpx-row",
                                                staticStyle: {
                                                  display: "flex",
                                                  "border-bottom":
                                                    "1px solid #CBCBCB",
                                                },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      display: "flex",
                                                      flex: "1",
                                                    },
                                                  },
                                                  [_vm._v("固收")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      display: "flex",
                                                      flex: "1",
                                                      "font-weight": "400",
                                                      "justify-content":
                                                        "flex-end",
                                                      "margin-right": "14px",
                                                      color: "black",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        parseFloat(
                                                          _vm.companyData.fxinc
                                                        ) == "NaN"
                                                          ? "--"
                                                          : _vm.companyData
                                                              .fxinc > 1
                                                          ? parseFloat(
                                                              _vm.companyData
                                                                .fxinc
                                                            )
                                                          : "<1"
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      display: "flex",
                                                      flex: "1",
                                                      "justify-content":
                                                        "flex-end",
                                                      color: "black",
                                                    },
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.companyData
                                                            .fxincrank == ""
                                                            ? "--"
                                                            : _vm.companyData
                                                                .fxincrank
                                                        )
                                                      ),
                                                    ]),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          color:
                                                            "rgb(161 161 161)",
                                                          "font-weight": "200",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.companyData
                                                              .fxincrank == ""
                                                              ? ""
                                                              : "/"
                                                          ) +
                                                            _vm._s(
                                                              _vm.companyData
                                                                .fxincrank == ""
                                                                ? ""
                                                                : _vm
                                                                    .companyReportData
                                                                    .fxincRankSize
                                                            )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "cpx-data-row" },
                                          [
                                            _vm._m(23),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "cpx-row",
                                                staticStyle: {
                                                  display: "flex",
                                                  "border-bottom":
                                                    "1px solid #CBCBCB",
                                                },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      display: "flex",
                                                      flex: "1",
                                                    },
                                                  },
                                                  [_vm._v("货币")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      display: "flex",
                                                      flex: "1",
                                                      "font-weight": "400",
                                                      "justify-content":
                                                        "flex-end",
                                                      "margin-right": "14px",
                                                      color: "black",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        parseFloat(
                                                          _vm.companyData.mnmkt
                                                        ) == "NaN"
                                                          ? "--"
                                                          : _vm.companyData
                                                              .mnmkt > 1
                                                          ? parseFloat(
                                                              _vm.companyData
                                                                .mnmkt
                                                            )
                                                          : "<1"
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      display: "flex",
                                                      flex: "1",
                                                      "justify-content":
                                                        "flex-end",
                                                      color: "black",
                                                    },
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.companyData
                                                            .mnmktrank == ""
                                                            ? "--"
                                                            : _vm.companyData
                                                                .mnmktrank
                                                        )
                                                      ),
                                                    ]),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          color:
                                                            "rgb(161 161 161)",
                                                          "font-weight": "200",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.companyData
                                                              .mnmktrank == ""
                                                              ? ""
                                                              : "/"
                                                          ) +
                                                            _vm._s(
                                                              _vm.companyData
                                                                .mnmktrank == ""
                                                                ? ""
                                                                : _vm
                                                                    .companyReportData
                                                                    .mnmktRankSize
                                                            )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "cpx-data-row" },
                                          [
                                            _vm._m(24),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "cpx-row",
                                                staticStyle: {
                                                  display: "flex",
                                                },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      display: "flex",
                                                      flex: "1",
                                                    },
                                                  },
                                                  [_vm._v("其他")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      display: "flex",
                                                      flex: "1",
                                                      "font-weight": "400",
                                                      "justify-content":
                                                        "flex-end",
                                                      "margin-right": "14px",
                                                      color: "black",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        parseFloat(
                                                          _vm.companyData.other
                                                        ) == "NaN"
                                                          ? "--"
                                                          : _vm.companyData
                                                              .other > 1
                                                          ? parseFloat(
                                                              _vm.companyData
                                                                .other
                                                            )
                                                          : "<1"
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      display: "flex",
                                                      flex: "1",
                                                      "font-weight": "200",
                                                      "justify-content":
                                                        "flex-end",
                                                      color: "black",
                                                    },
                                                  },
                                                  [_vm._v("--")]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.companyIndexInfo
                                        .passivityFundSizeRatio != "",
                                    expression:
                                      "companyIndexInfo.passivityFundSizeRatio != ''",
                                  },
                                ],
                                staticClass: "box-left1-bottom-area",
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      width: "100%",
                                      height: "158px",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "cpx-left-area2" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              width: "180px",
                                              height: "100%",
                                            },
                                          },
                                          [
                                            _c("v-chart", {
                                              staticStyle: {
                                                width: "100%",
                                                height: "180px",
                                                left: "-15px",
                                              },
                                              attrs: {
                                                option: _vm.orgOptions2,
                                                autoresize: "",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "cpx-right-area2" },
                                      [
                                        _vm._m(25),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "cpx-data-row2" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "cpx-row",
                                                staticStyle: {
                                                  display: "flex",
                                                },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      display: "flex",
                                                      flex: "1",
                                                    },
                                                  },
                                                  [_vm._v("指数型")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      display: "flex",
                                                      flex: "1",
                                                      "font-weight": "400",
                                                      "justify-content":
                                                        "flex-end",
                                                      color: "black",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.companyIndexInfo
                                                          .indexFundSize == ""
                                                          ? "--"
                                                          : parseFloat(
                                                              _vm
                                                                .companyIndexInfo
                                                                .indexFundSize
                                                            ).toFixed(1)
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      display: "flex",
                                                      flex: "1",
                                                      "justify-content":
                                                        "flex-end",
                                                      color: "black",
                                                    },
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.indexFundSizeRank ==
                                                            ""
                                                            ? "--"
                                                            : _vm.indexFundSizeRank.substring(
                                                                0,
                                                                _vm.indexFundSizeRank.lastIndexOf(
                                                                  "/"
                                                                )
                                                              )
                                                        )
                                                      ),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          color:
                                                            "rgb(161 161 161)",
                                                          "font-weight": "200",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.indexFundSizeRank ==
                                                              ""
                                                              ? ""
                                                              : _vm.indexFundSizeRank.substring(
                                                                  _vm.indexFundSizeRank.lastIndexOf(
                                                                    "/"
                                                                  )
                                                                )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "cpx-data-row2" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "cpx-row",
                                                staticStyle: {
                                                  display: "flex",
                                                },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      display: "flex",
                                                      flex: "1",
                                                      color:
                                                        "rgb(161, 161, 161)",
                                                    },
                                                  },
                                                  [_vm._v("  -权益指数")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      display: "flex",
                                                      flex: "1",
                                                      "font-weight": "400",
                                                      "justify-content":
                                                        "flex-end",
                                                      color: "black",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.companyIndexInfo
                                                          .equityIndexFundSize ==
                                                          ""
                                                          ? "--"
                                                          : parseFloat(
                                                              _vm
                                                                .companyIndexInfo
                                                                .equityIndexFundSize
                                                            ).toFixed(1)
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      display: "flex",
                                                      flex: "1",
                                                      "justify-content":
                                                        "flex-end",
                                                      color: "black",
                                                    },
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.equityIndexFundSizeRank ==
                                                            ""
                                                            ? "--"
                                                            : _vm.equityIndexFundSizeRank.substring(
                                                                0,
                                                                _vm.equityIndexFundSizeRank.lastIndexOf(
                                                                  "/"
                                                                )
                                                              )
                                                        )
                                                      ),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          color:
                                                            "rgb(161 161 161)",
                                                          "font-weight": "200",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.equityIndexFundSizeRank ==
                                                              ""
                                                              ? ""
                                                              : _vm.equityIndexFundSizeRank.substring(
                                                                  _vm.equityIndexFundSizeRank.lastIndexOf(
                                                                    "/"
                                                                  )
                                                                )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "cpx-data-row2" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "cpx-row",
                                                staticStyle: {
                                                  display: "flex",
                                                },
                                              },
                                              [
                                                _vm._m(26),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      display: "flex",
                                                      flex: "1",
                                                      "font-weight": "400",
                                                      "justify-content":
                                                        "flex-end",
                                                      color: "black",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.companyIndexInfo
                                                          .enhanceIndexFundSize ==
                                                          ""
                                                          ? "--"
                                                          : parseFloat(
                                                              _vm
                                                                .companyIndexInfo
                                                                .enhanceIndexFundSize
                                                            ).toFixed(1)
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      display: "flex",
                                                      flex: "1",
                                                      "justify-content":
                                                        "flex-end",
                                                      color: "black",
                                                    },
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.enhanceIndexFundSizeRank ==
                                                            ""
                                                            ? "--"
                                                            : _vm.enhanceIndexFundSizeRank.substring(
                                                                0,
                                                                _vm.enhanceIndexFundSizeRank.lastIndexOf(
                                                                  "/"
                                                                )
                                                              )
                                                        )
                                                      ),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          color:
                                                            "rgb(161 161 161)",
                                                          "font-weight": "200",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.enhanceIndexFundSizeRank ==
                                                              ""
                                                              ? ""
                                                              : _vm.enhanceIndexFundSizeRank.substring(
                                                                  _vm.enhanceIndexFundSizeRank.lastIndexOf(
                                                                    "/"
                                                                  )
                                                                )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "cpx-left-bottom-area" },
                                  [
                                    _vm._m(27),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          "margin-right": "14px",
                                          "font-size": "14px",
                                        },
                                      },
                                      [
                                        _vm._v("主动型 "),
                                        _c(
                                          "span",
                                          { staticStyle: { color: "black" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.companyIndexInfo
                                                  .activeFundSizeRatio == ""
                                                  ? "--"
                                                  : parseFloat(
                                                      _vm.companyIndexInfo
                                                        .activeFundSizeRatio
                                                    ).toFixed(2)
                                              ) + "%"
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _vm._m(28),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticStyle: { "font-size": "14px" } },
                                      [
                                        _vm._v("指数及指数增强 "),
                                        _c(
                                          "span",
                                          { staticStyle: { color: "black" } },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.companyIndexInfo
                                                  .passivityFundSizeRatio == ""
                                                  ? "--"
                                                  : parseFloat(
                                                      _vm.companyIndexInfo
                                                        .passivityFundSizeRatio
                                                    ).toFixed(2)
                                              ) + "%"
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "box-left6" }, [
                          _c("div", { staticClass: "content-left-top-area2" }, [
                            _c("span", {
                              staticClass: "flImgClass",
                              domProps: { innerHTML: _vm._s(_vm.FLlogo) },
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "desc-text5" }, [
                              _vm._v("费率"),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "content-area" }, [
                            _vm._m(29),
                            _vm._v(" "),
                            _c("div", { staticClass: "fl-content-area2" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "fl-content-title",
                                  staticStyle: {
                                    "font-size": "13px",
                                    "font-weight": "550",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                                                综合得分"
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "fl-content-data",
                                  staticStyle: { color: "black" },
                                },
                                [
                                  _vm._v(
                                    "\n                                                " +
                                      _vm._s(
                                        _vm.companyData.terscore == ""
                                          ? "--"
                                          : _vm.companyData.terscore
                                      )
                                  ),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "fl-content-area2" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "fl-content-title",
                                  staticStyle: {
                                    "font-size": "13px",
                                    "font-weight": "550",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                                                排名"
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "fl-content-data",
                                  staticStyle: { color: "black" },
                                },
                                [
                                  _vm._v(
                                    "\n                                                " +
                                      _vm._s(
                                        _vm.companyData.terscoreRank == ""
                                          ? "--"
                                          : _vm.companyData.terscoreRank
                                      )
                                  ),
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        "font-weight": "200",
                                        color: "rgb(161 161 161)",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.companyData.terscoreRank == ""
                                            ? ""
                                            : "/"
                                        ) +
                                          _vm._s(
                                            _vm.companyData.terscoreRank == ""
                                              ? ""
                                              : _vm.companyReportData
                                                  .terscoreRankSize
                                          )
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]),
                          ]),
                        ]),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "content-main3-area" }, [
                    _c("div", { staticClass: "bottom1-area" }, [
                      _c("span", { staticStyle: { "font-weight": "600" } }, [
                        _vm._v("数据来源："),
                      ]),
                      _c("span", [
                        _vm._v(
                          "Morningstar（晨星）；数据截⾄" +
                            _vm._s(_vm.companyReportData.latestDate) +
                            "，如⽆特殊说明以⼈⺠币计算。"
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _vm._m(30),
                  ]),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading,
                    expression: "loading",
                  },
                ],
                ref: "productReportPageRef",
                staticClass: "page-module",
                attrs: {
                  "element-loading-text": "加速生成中",
                  "element-loading-spinner": "el-icon-loading",
                  "element-loading-background": "rgba(0, 0, 0, 0.8)",
                },
              },
              [
                _c("div", { staticClass: "page-area" }, [
                  _c("div", { staticClass: "top-area" }, [
                    _c("div", { staticClass: "top-left-area" }, [
                      _c("span", { staticClass: "top-left-area-title" }, [
                        _vm._v("中国基金公司量化数据报告 "),
                      ]),
                      _c("span", { staticClass: "line-area" }, [_vm._v("|")]),
                      _c("span", { staticClass: "top-left-area-date" }, [
                        _vm._v(
                          "\n                                " +
                            _vm._s(_vm.companyReportData.quarterStr)
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _vm._m(31),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "content-main6-area" }, [
                    _c("div", { staticClass: "content-main6-right" }, [
                      _c("div", { staticClass: "box-right7" }, [
                        _c("div", { staticClass: "content-left-top-area3" }, [
                          _c("span", {
                            staticClass: "zjlImgClass",
                            domProps: { innerHTML: _vm._s(_vm.ZJLlogo) },
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "desc-text4" }, [
                            _vm._v("资金流"),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "zjl-area" }, [
                          _c("div", { staticClass: "zjl-left-area" }, [
                            _vm._m(32),
                            _vm._v(" "),
                            _c("div", { staticClass: "gm-row" }, [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    flex: "3",
                                    "justify-content": "flex-start",
                                  },
                                },
                                [_vm._v("最近⼀年净流⼊(亿元)")]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    flex: "1",
                                    "justify-content": "flex-end",
                                    color: "black",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      parseFloat(
                                        _vm.companyData.fundSizeFlow_1Y
                                      ).toFixed(0) == "NaN"
                                        ? "--"
                                        : parseFloat(
                                            _vm.companyData.fundSizeFlow_1Y
                                          ).toFixed(0)
                                    )
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    flex: "1.5",
                                    "justify-content": "flex-end",
                                    color: "black",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.companyData.fundSizeFlowRank_1Y == ""
                                        ? "--"
                                        : _vm.companyData.fundSizeFlowRank_1Y
                                    )
                                  ),
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        "font-weight": "200",
                                        color: "rgb(161, 161, 161)",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.companyData.fundSizeFlowRank_1Y ==
                                            ""
                                            ? ""
                                            : "/"
                                        ) +
                                          _vm._s(
                                            _vm.companyData
                                              .fundSizeFlowRank_1Y == ""
                                              ? ""
                                              : _vm.companyReportData
                                                  .fundSizeFlowRank1YSize
                                          )
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "gm-row" }, [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    flex: "3",
                                    "justify-content": "flex-start",
                                  },
                                },
                                [_vm._v("最近⼀年增⻓率")]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    flex: "1",
                                    "justify-content": "flex-end",
                                    color: "black",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.companyData.fundSizeFlowPer_1Y == ""
                                        ? "--"
                                        : _vm.companyData.fundSizeFlowPer_1Y
                                    ) +
                                      _vm._s(
                                        _vm.companyData.fundSizeFlowPer_1Y == ""
                                          ? ""
                                          : "%"
                                      )
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    flex: "1.5",
                                    "justify-content": "flex-end",
                                    color: "black",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.companyData.fundSizeFlowPerRank_1Y ==
                                        ""
                                        ? "--"
                                        : _vm.companyData.fundSizeFlowPerRank_1Y
                                    )
                                  ),
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        "font-weight": "200",
                                        color: "rgb(161, 161, 161)",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.companyData
                                            .fundSizeFlowPerRank_1Y == ""
                                            ? ""
                                            : "/"
                                        ) +
                                          _vm._s(
                                            _vm.companyData
                                              .fundSizeFlowPerRank_1Y == ""
                                              ? ""
                                              : _vm.companyReportData
                                                  .fundSizeFlowPerRank1YSize
                                          )
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "gm-row" }, [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    flex: "3",
                                    "justify-content": "flex-start",
                                  },
                                },
                                [_vm._v("最近三年净流⼊(亿元)")]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    flex: "1",
                                    "justify-content": "flex-end",
                                    color: "black",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      parseFloat(
                                        _vm.companyData.fundSizeFlow_3Y
                                      ).toFixed(0) == "NaN"
                                        ? "--"
                                        : parseFloat(
                                            _vm.companyData.fundSizeFlow_3Y
                                          ).toFixed(0)
                                    )
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    flex: "1.5",
                                    "justify-content": "flex-end",
                                    color: "black",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.companyData.fundSizeFlowRank_3Y == ""
                                        ? "--"
                                        : _vm.companyData.fundSizeFlowRank_3Y
                                    )
                                  ),
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        "font-weight": "200",
                                        color: "rgb(161, 161, 161)",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.companyData.fundSizeFlowRank_3Y ==
                                            ""
                                            ? ""
                                            : "/"
                                        ) +
                                          _vm._s(
                                            _vm.companyData
                                              .fundSizeFlowRank_3Y == ""
                                              ? ""
                                              : _vm.companyReportData
                                                  .fundSizeFlowRank3YSize
                                          )
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "gm-row" }, [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    flex: "3",
                                    "justify-content": "flex-start",
                                  },
                                },
                                [_vm._v("最近三年增⻓率")]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    flex: "1",
                                    "justify-content": "flex-end",
                                    color: "black",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.companyData.fundSizeFlowPer_3Y == ""
                                        ? "--"
                                        : _vm.companyData.fundSizeFlowPer_3Y
                                    ) +
                                      _vm._s(
                                        _vm.companyData.fundSizeFlowPer_3Y == ""
                                          ? ""
                                          : "%"
                                      )
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    flex: "1.5",
                                    "justify-content": "flex-end",
                                    color: "black",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.companyData.fundSizeFlowPerRank_3Y ==
                                        ""
                                        ? "--"
                                        : _vm.companyData.fundSizeFlowPerRank_3Y
                                    )
                                  ),
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        "font-weight": "200",
                                        color: "rgb(161, 161, 161)",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.companyData
                                            .fundSizeFlowPerRank_3Y == ""
                                            ? ""
                                            : "/"
                                        ) +
                                          _vm._s(
                                            _vm.companyData
                                              .fundSizeFlowPerRank_3Y == ""
                                              ? ""
                                              : _vm.companyReportData
                                                  .fundSizeFlowPerRank3YSize
                                          )
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "zjl-right-area" }, [
                            _c("div", { staticClass: "zjl-right-box" }, [
                              _c("div", { staticClass: "zjl-content-box" }, [
                                _vm._m(33),
                                _vm._v(" "),
                                _vm.fundInflow.length > 0
                                  ? _c(
                                      "div",
                                      _vm._l(_vm.fundInflow, function (item) {
                                        return _c(
                                          "div",
                                          { key: item, staticClass: "gm-row" },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  display: "flex",
                                                  flex: "5",
                                                  "justify-content":
                                                    "flex-start",
                                                  "text-align": "left",
                                                },
                                              },
                                              [_vm._v(_vm._s(item.fundName))]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  display: "flex",
                                                  flex: "1",
                                                  "justify-content": "flex-end",
                                                },
                                              },
                                              [_vm._v(_vm._s(item.symbol))]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  display: "flex",
                                                  flex: "2.5",
                                                  "justify-content": "flex-end",
                                                  color: "black",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    item.flow == ""
                                                      ? "--"
                                                      : parseFloat(
                                                          item.flow
                                                        ).toFixed(2)
                                                  )
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  display: "flex",
                                                  flex: "2",
                                                  "justify-content": "flex-end",
                                                  color: "black",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    item.fundSize == ""
                                                      ? "--"
                                                      : parseFloat(
                                                          item.fundSize
                                                        ).toFixed(2)
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      }),
                                      0
                                    )
                                  : _c("div", [
                                      _c(
                                        "div",
                                        { staticClass: "null-node-area" },
                                        [
                                          _vm._v(
                                            "\n                                                        暂无信息\n                                                    "
                                          ),
                                        ]
                                      ),
                                    ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "zjl-content-box" }, [
                                _vm._m(34),
                                _vm._v(" "),
                                _vm.fundOutflow.length > 0
                                  ? _c(
                                      "div",
                                      _vm._l(_vm.fundOutflow, function (item) {
                                        return _c(
                                          "div",
                                          { key: item, staticClass: "gm-row" },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  display: "flex",
                                                  flex: "5",
                                                  "justify-content":
                                                    "flex-start",
                                                  "text-align": "left",
                                                },
                                              },
                                              [_vm._v(_vm._s(item.fundName))]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  display: "flex",
                                                  flex: "1",
                                                  "justify-content": "flex-end",
                                                },
                                              },
                                              [_vm._v(_vm._s(item.symbol))]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  display: "flex",
                                                  flex: "2.5",
                                                  "justify-content": "flex-end",
                                                  color: "black",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    item.flow == ""
                                                      ? "--"
                                                      : parseFloat(
                                                          item.flow
                                                        ).toFixed(2)
                                                  )
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  display: "flex",
                                                  flex: "2",
                                                  "justify-content": "flex-end",
                                                  color: "black",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    item.fundSize == ""
                                                      ? "--"
                                                      : parseFloat(
                                                          item.fundSize
                                                        ).toFixed(2)
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      }),
                                      0
                                    )
                                  : _c("div", [
                                      _c(
                                        "div",
                                        { staticClass: "null-node-area" },
                                        [
                                          _vm._v(
                                            "\n                                                        暂无信息\n                                                    "
                                          ),
                                        ]
                                      ),
                                    ]),
                              ]),
                            ]),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "box-right9" }, [
                        _c("div", { staticClass: "content-left-top-area9" }, [
                          _c("span", {
                            staticClass: "zjlImgClass",
                            domProps: { innerHTML: _vm._s(_vm.ZJLlogo) },
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "desc-text4" }, [
                            _vm._v("产品动态"),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", {
                          ref: "page1FundStartRef",
                          staticClass: "fund-start-marker",
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.page1NewFundShow,
                                expression: "page1NewFundShow",
                              },
                            ],
                            ref: "page1NewFundRef",
                            staticClass: "cpct-area",
                          },
                          [
                            _vm._m(35),
                            _vm._v(" "),
                            _vm.newFund.length != 0
                              ? _c(
                                  "div",
                                  { staticStyle: { "margin-bottom": "10px" } },
                                  _vm._l(_vm.page1NewFundList, function (item) {
                                    return _c(
                                      "div",
                                      {
                                        key: item,
                                        staticClass: "gm-row fund-content-row",
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              display: "flex",
                                              flex: "1",
                                              "justify-content": "flex-start",
                                              "text-align": "left",
                                            },
                                          },
                                          [_vm._v(_vm._s(item.symbol))]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              display: "flex",
                                              flex: "4",
                                              "justify-content": "flex-start",
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  display: "flex",
                                                  "margin-left": "10px",
                                                  "justify-content":
                                                    "flex-start",
                                                  "text-align": "left",
                                                },
                                              },
                                              [_vm._v(_vm._s(item.fundName))]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              display: "flex",
                                              flex: "2",
                                              "justify-content": "flex-start",
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  display: "flex",
                                                  "justify-content":
                                                    "flex-start",
                                                  "margin-left": "10px",
                                                  "text-align": "left",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    item.managerName == ""
                                                      ? "--"
                                                      : item.managerName
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              display: "flex",
                                              flex: "2",
                                              "justify-content": "flex-start",
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  display: "flex",
                                                  "justify-content":
                                                    "flex-start",
                                                  "margin-left": "10px",
                                                  "text-align": "left",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(item.categoryName)
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              display: "flex",
                                              flex: "2",
                                              "justify-content": "center",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                item.inceptionDate.substr(0, 10)
                                              )
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              display: "flex",
                                              flex: "1.5",
                                              "justify-content": "flex-end",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                item.fundSize == ""
                                                  ? "--"
                                                  : parseFloat(
                                                      item.fundSize
                                                    ).toFixed(2)
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  }),
                                  0
                                )
                              : _c("div", [
                                  _c("div", { staticClass: "null-node-area" }, [
                                    _vm._v(
                                      "\n                                            暂无信息\n                                        "
                                    ),
                                  ]),
                                ]),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.page1ObsoleteFundShow,
                              expression: "page1ObsoleteFundShow",
                            },
                          ],
                          ref: "page1ObsoleteFundRef",
                          staticClass: "cpct-area2",
                          style: { "border-top": _vm.borderTop },
                        },
                        [
                          _vm._m(36),
                          _vm._v(" "),
                          _vm.page1ObsoleteFundList.length !== 0
                            ? _c(
                                "div",
                                { staticStyle: { "margin-bottom": "10px" } },
                                _vm._l(
                                  _vm.page1ObsoleteFundList,
                                  function (item) {
                                    return _c(
                                      "div",
                                      {
                                        key: item,
                                        staticClass: "gm-row fund-content-row",
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              display: "flex",
                                              flex: "1",
                                              "justify-content": "flex-start",
                                              "text-align": "left",
                                            },
                                          },
                                          [_vm._v(_vm._s(item.symbol))]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              display: "flex",
                                              flex: "4",
                                              "justify-content": "flex-start",
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  display: "flex",
                                                  "margin-left": "10px",
                                                  "justify-content":
                                                    "flex-start",
                                                  "text-align": "left",
                                                },
                                              },
                                              [_vm._v(_vm._s(item.fundName))]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              display: "flex",
                                              flex: "2",
                                              "justify-content": "flex-start",
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  display: "flex",
                                                  "justify-content":
                                                    "flex-start",
                                                  "margin-left": "10px",
                                                  "text-align": "left",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    item.managerName == ""
                                                      ? "--"
                                                      : item.managerName
                                                  )
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              display: "flex",
                                              flex: "2",
                                              "justify-content": "flex-start",
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  display: "flex",
                                                  "justify-content":
                                                    "flex-start",
                                                  "margin-left": "10px",
                                                  "text-align": "left",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(item.categoryName)
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              display: "flex",
                                              flex: "2",
                                              "justify-content": "center",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                item.inceptionDate.substr(0, 10)
                                              )
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              display: "flex",
                                              flex: "1.5",
                                              "justify-content": "flex-end",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                item.obsoleteDate.substr(0, 10)
                                              )
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                0
                              )
                            : _c("div", [
                                _c("div", { staticClass: "null-node-area" }, [
                                  _vm._v(
                                    "\n                                        暂无信息\n                                    "
                                  ),
                                ]),
                              ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.page1MiniFundShow,
                              expression: "page1MiniFundShow",
                            },
                          ],
                          ref: "page1MiniFundRef",
                          staticClass: "cpct-area66",
                        },
                        [
                          _vm._m(37),
                          _vm._v(" "),
                          _vm.page1MiniFundList.length != 0
                            ? _c(
                                "div",
                                { staticStyle: { "margin-bottom": "10px" } },
                                _vm._l(_vm.page1MiniFundList, function (item) {
                                  return _c(
                                    "div",
                                    {
                                      key: item,
                                      staticClass: "gm-row3 fund-content-row",
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            flex: "1",
                                            "justify-content": "flex-start",
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                display: "flex",
                                                width: "83px",
                                                "justify-content": "flex-start",
                                                "text-align": "left",
                                              },
                                            },
                                            [_vm._v(_vm._s(item.symbol))]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            flex: "7",
                                            "justify-content": "flex-start",
                                            "text-align": "left",
                                          },
                                        },
                                        [_vm._v(_vm._s(item.fundName))]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            flex: "3.5",
                                            "justify-content": "flex-start",
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                display: "flex",
                                                "justify-content": "flex-start",
                                                "margin-left": "5px",
                                                "text-align": "left",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  item.managerName == ""
                                                    ? "--"
                                                    : item.managerName
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            flex: "3.8",
                                            "justify-content": "flex-start",
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                display: "flex",
                                                "justify-content": "flex-start",
                                                "margin-left": "10px",
                                                "text-align": "left",
                                              },
                                            },
                                            [_vm._v(_vm._s(item.categoryName))]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            flex: "2.5",
                                            "justify-content": "flex-end",
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                "margin-right": "19px",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  item.fundSize == ""
                                                    ? "--"
                                                    : parseFloat(
                                                        item.fundSize
                                                      ).toFixed(2)
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            flex: "1.5",
                                            "justify-content": "flex-end",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              item.index == true ? "是" : "否"
                                            )
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            flex: "2",
                                            "justify-content": "flex-end",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              item.init == true ? "是" : "否"
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                }),
                                0
                              )
                            : _c("div", [
                                _c("div", { staticClass: "null-node-area" }, [
                                  _vm._v(
                                    "\n                                        暂无信息\n                                    "
                                  ),
                                ]),
                              ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.page1FundCountShow,
                              expression: "page1FundCountShow",
                            },
                          ],
                          staticClass: "cpct-area3",
                        },
                        [
                          _c("div", { staticClass: "cpct-box3" }, [
                            _c(
                              "div",
                              {
                                staticClass: "gm-row2",
                                staticStyle: { width: "200px" },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      flex: "2",
                                      "justify-content": "flex-start",
                                      "font-weight": "550",
                                    },
                                  },
                                  [_vm._v("基金数量")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      flex: "1",
                                      "justify-content": "flex-end",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.companyIndexInfo.miniFundCount)
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "gm-row2",
                                staticStyle: { width: "200px" },
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      flex: "2",
                                      "justify-content": "flex-start",
                                      "font-weight": "550",
                                    },
                                  },
                                  [_vm._v("数量占比")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      display: "flex",
                                      flex: "1",
                                      "justify-content": "flex-end",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.companyIndexInfo
                                          .miniFundCountRatio == ""
                                          ? "--"
                                          : parseFloat(
                                              _vm.companyIndexInfo
                                                .miniFundCountRatio
                                            ).toFixed(2)
                                      ) +
                                        _vm._s(
                                          _vm.companyIndexInfo
                                            .miniFundCountRatio == ""
                                            ? ""
                                            : "%"
                                        )
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]),
                        ]
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "content-main3-area" }, [
                    _c("div", { staticClass: "bottom1-area" }, [
                      _c("span", { staticStyle: { "font-weight": "600" } }, [
                        _vm._v("数据来源："),
                      ]),
                      _c("span", [
                        _vm._v(
                          "Morningstar（晨星）；数据截⾄" +
                            _vm._s(_vm.companyReportData.latestDate) +
                            "，如⽆特殊说明以⼈⺠币计算。"
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _vm._m(38),
                  ]),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                ref: "fundMeasureRef",
                staticClass: "fund-measure-container",
                attrs: { "aria-hidden": "true" },
              },
              [
                _c(
                  "div",
                  {
                    ref: "fundMeasureNewSectionRef",
                    staticClass: "fund-dynamic-section",
                    class: {
                      "fund-dynamic-section--has-data": _vm.newFund.length,
                    },
                    attrs: { "data-fund-section": "newFund" },
                  },
                  [
                    _c(
                      "div",
                      {
                        ref: "fundMeasureNewHeaderRef",
                        staticClass: "fixed-header",
                      },
                      [
                        _c("div", { staticClass: "fund-section-title" }, [
                          _vm._v("新发基金(近一年)"),
                        ]),
                        _vm._v(" "),
                        _vm._m(39),
                      ]
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.newFund, function (item, index) {
                      return _c(
                        "div",
                        {
                          key: "measure-new-" + index,
                          staticClass: "gm-row fund-standard-row",
                          attrs: {
                            "data-fund-type": "newFund",
                            "data-fund-index": index,
                          },
                        },
                        [
                          _c("span", [_vm._v(_vm._s(item.symbol))]),
                          _c("span", [_vm._v(_vm._s(item.fundName))]),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                item.managerName == "" ? "--" : item.managerName
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(item.categoryName))]),
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.formatFundDate(item.inceptionDate))
                            ),
                          ]),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                item.fundSize == ""
                                  ? "--"
                                  : parseFloat(item.fundSize).toFixed(2)
                              )
                            ),
                          ]),
                        ]
                      )
                    }),
                    _vm._v(" "),
                    !_vm.newFund.length
                      ? _c("div", { staticClass: "null-node-area" }, [
                          _vm._v("暂无信息"),
                        ])
                      : _vm._e(),
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    ref: "fundMeasureObsoleteSectionRef",
                    staticClass:
                      "fund-dynamic-section fund-dynamic-section--bordered",
                    class: {
                      "fund-dynamic-section--has-data": _vm.obsoleteFund.length,
                    },
                    attrs: { "data-fund-section": "obsoleteFund" },
                  },
                  [
                    _c(
                      "div",
                      {
                        ref: "fundMeasureObsoleteHeaderRef",
                        staticClass: "fixed-header",
                      },
                      [
                        _c("div", { staticClass: "fund-section-title" }, [
                          _vm._v("基金清盘(近一年)"),
                        ]),
                        _vm._v(" "),
                        _vm._m(40),
                      ]
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.obsoleteFund, function (item, index) {
                      return _c(
                        "div",
                        {
                          key: "measure-obsolete-" + index,
                          staticClass: "gm-row fund-standard-row",
                          attrs: {
                            "data-fund-type": "obsoleteFund",
                            "data-fund-index": index,
                          },
                        },
                        [
                          _c("span", [_vm._v(_vm._s(item.symbol))]),
                          _c("span", [_vm._v(_vm._s(item.fundName))]),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                item.managerName == "" ? "--" : item.managerName
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(item.categoryName))]),
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.formatFundDate(item.inceptionDate))
                            ),
                          ]),
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.formatFundDate(item.obsoleteDate))
                            ),
                          ]),
                        ]
                      )
                    }),
                    _vm._v(" "),
                    !_vm.obsoleteFund.length
                      ? _c("div", { staticClass: "null-node-area" }, [
                          _vm._v("暂无信息"),
                        ])
                      : _vm._e(),
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    ref: "fundMeasureMiniSectionRef",
                    staticClass:
                      "fund-dynamic-section fund-dynamic-section--bordered",
                    class: {
                      "fund-dynamic-section--has-data": _vm.miniFund.length,
                    },
                    attrs: { "data-fund-section": "miniFund" },
                  },
                  [
                    _c(
                      "div",
                      {
                        ref: "fundMeasureMiniHeaderRef",
                        staticClass: "fixed-header",
                      },
                      [
                        _c("div", { staticClass: "fund-section-title" }, [
                          _vm._v("迷你基金(规模不足一亿)"),
                        ]),
                        _vm._v(" "),
                        _vm._m(41),
                      ]
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.miniFund, function (item, index) {
                      return _c(
                        "div",
                        {
                          key: "measure-mini-" + index,
                          staticClass: "gm-row3 fund-mini-row",
                          attrs: {
                            "data-fund-type": "miniFund",
                            "data-fund-index": index,
                          },
                        },
                        [
                          _c("span", [_vm._v(_vm._s(item.symbol))]),
                          _c("span", [_vm._v(_vm._s(item.fundName))]),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                item.managerName == "" ? "--" : item.managerName
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(item.categoryName))]),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                item.fundSize == ""
                                  ? "--"
                                  : parseFloat(item.fundSize).toFixed(2)
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(_vm._s(item.index ? "是" : "否")),
                          ]),
                          _c("span", [_vm._v(_vm._s(item.init ? "是" : "否"))]),
                        ]
                      )
                    }),
                    _vm._v(" "),
                    !_vm.miniFund.length
                      ? _c("div", { staticClass: "null-node-area" }, [
                          _vm._v("暂无信息"),
                        ])
                      : _vm._e(),
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { ref: "fundMeasureEmptyRef", staticClass: "null-node-area" },
                  [_vm._v("暂无信息")]
                ),
                _vm._v(" "),
                _c("div", {
                  ref: "fundMeasureSummaryRef",
                  staticClass: "cpct-area3",
                }),
              ]
            ),
            _vm._v(" "),
            _vm._l(_vm.fundPages.slice(1), function (fundPage, fundPageIndex) {
              return _c(
                "div",
                {
                  key: "fund-page-" + fundPageIndex,
                  staticClass: "page-module",
                },
                [
                  _c("div", { staticClass: "page-area" }, [
                    _c("div", { staticClass: "top-area" }, [
                      _c("div", { staticClass: "top-left-area" }, [
                        _c("span", { staticClass: "top-left-area-title" }, [
                          _vm._v("中国基金公司量化数据报告 "),
                        ]),
                        _c("span", { staticClass: "line-area" }, [_vm._v("|")]),
                        _c("span", { staticClass: "top-left-area-date" }, [
                          _vm._v(_vm._s(_vm.companyReportData.quarterStr)),
                        ]),
                      ]),
                      _vm._v(" "),
                      _vm._m(42, true),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "page-limit-area" },
                      [
                        _vm._l(
                          fundPage.sections,
                          function (section, sectionIndex) {
                            return _c(
                              "div",
                              {
                                key: section.type + "-" + sectionIndex,
                                staticClass: "fund-dynamic-section",
                                class: {
                                  "fund-dynamic-section--bordered":
                                    section.type !== "newFund",
                                  "fund-dynamic-section--has-data":
                                    section.items.length,
                                },
                              },
                              [
                                _c("div", { staticClass: "fixed-header" }, [
                                  _c(
                                    "div",
                                    { staticClass: "fund-section-title" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.fundSectionTitle(section.type)
                                        )
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  section.type !== "miniFund"
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "gm-row fund-standard-row fund-table-header",
                                        },
                                        [
                                          _c("span", [_vm._v("基金代码")]),
                                          _c("span", [_vm._v("基金名称")]),
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                section.type === "newFund"
                                                  ? "首发基金经理"
                                                  : "基金经理"
                                              )
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("span", [_vm._v("晨星分类")]),
                                          _c("span", [_vm._v("成立日期")]),
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                section.type === "newFund"
                                                  ? "首发规模(亿元)"
                                                  : "清盘日期"
                                              )
                                            ),
                                          ]),
                                        ]
                                      )
                                    : _c(
                                        "div",
                                        {
                                          staticClass:
                                            "gm-row3 fund-mini-row fund-table-header",
                                        },
                                        [
                                          _c("span", [_vm._v("基金代码")]),
                                          _c("span", [_vm._v("基金名称")]),
                                          _c("span", [_vm._v("基金经理")]),
                                          _c("span", [_vm._v("晨星分类")]),
                                          _c("span", [
                                            _vm._v("最新规模(亿元)"),
                                          ]),
                                          _c("span", [_vm._v("是否指数")]),
                                          _c("span", [_vm._v("是否发起式")]),
                                        ]
                                      ),
                                ]),
                                _vm._v(" "),
                                section.items.length
                                  ? [
                                      section.type === "newFund"
                                        ? _vm._l(
                                            section.items,
                                            function (item, itemIndex) {
                                              return _c(
                                                "div",
                                                {
                                                  key:
                                                    section.startIndex +
                                                    itemIndex,
                                                  staticClass:
                                                    "gm-row fund-standard-row",
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(_vm._s(item.symbol)),
                                                  ]),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(item.fundName)
                                                    ),
                                                  ]),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        item.managerName == ""
                                                          ? "--"
                                                          : item.managerName
                                                      )
                                                    ),
                                                  ]),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(item.categoryName)
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.formatFundDate(
                                                          item.inceptionDate
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        item.fundSize == ""
                                                          ? "--"
                                                          : parseFloat(
                                                              item.fundSize
                                                            ).toFixed(2)
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              )
                                            }
                                          )
                                        : section.type === "obsoleteFund"
                                        ? _vm._l(
                                            section.items,
                                            function (item, itemIndex) {
                                              return _c(
                                                "div",
                                                {
                                                  key:
                                                    section.startIndex +
                                                    itemIndex,
                                                  staticClass:
                                                    "gm-row fund-standard-row",
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(_vm._s(item.symbol)),
                                                  ]),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(item.fundName)
                                                    ),
                                                  ]),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        item.managerName == ""
                                                          ? "--"
                                                          : item.managerName
                                                      )
                                                    ),
                                                  ]),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(item.categoryName)
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.formatFundDate(
                                                          item.inceptionDate
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.formatFundDate(
                                                          item.obsoleteDate
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              )
                                            }
                                          )
                                        : _vm._l(
                                            section.items,
                                            function (item, itemIndex) {
                                              return _c(
                                                "div",
                                                {
                                                  key:
                                                    section.startIndex +
                                                    itemIndex,
                                                  staticClass:
                                                    "gm-row3 fund-mini-row",
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(_vm._s(item.symbol)),
                                                  ]),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(item.fundName)
                                                    ),
                                                  ]),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        item.managerName == ""
                                                          ? "--"
                                                          : item.managerName
                                                      )
                                                    ),
                                                  ]),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(item.categoryName)
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        item.fundSize == ""
                                                          ? "--"
                                                          : parseFloat(
                                                              item.fundSize
                                                            ).toFixed(2)
                                                      )
                                                    ),
                                                  ]),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        item.index ? "是" : "否"
                                                      )
                                                    ),
                                                  ]),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        item.init ? "是" : "否"
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              )
                                            }
                                          ),
                                    ]
                                  : _c(
                                      "div",
                                      { staticClass: "null-node-area" },
                                      [_vm._v("暂无信息")]
                                    ),
                              ],
                              2
                            )
                          }
                        ),
                        _vm._v(" "),
                        fundPage.showSummary
                          ? _c("div", { staticClass: "cpct-area3" }, [
                              _c("div", { staticClass: "cpct-box3" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "gm-row2",
                                    staticStyle: { width: "200px" },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          flex: "2",
                                          "font-weight": "550",
                                        },
                                      },
                                      [_vm._v("基金数量")]
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          flex: "1",
                                          "text-align": "right",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.companyIndexInfo.miniFundCount
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "gm-row2",
                                    staticStyle: { width: "200px" },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          flex: "2",
                                          "font-weight": "550",
                                        },
                                      },
                                      [_vm._v("数量占比")]
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          flex: "1",
                                          "text-align": "right",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.formatFundRatio(
                                              _vm.companyIndexInfo
                                                .miniFundCountRatio
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]),
                            ])
                          : _vm._e(),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "content-main3-area" }, [
                      _c("div", { staticClass: "bottom1-area" }, [
                        _c("span", { staticStyle: { "font-weight": "600" } }, [
                          _vm._v("数据来源："),
                        ]),
                        _c("span", [
                          _vm._v(
                            "Morningstar（晨星）；数据截⾄" +
                              _vm._s(_vm.companyReportData.latestDate) +
                              "，如⽆特殊说明以⼈⺠币计算。"
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _vm._m(43, true),
                    ]),
                  ]),
                ]
              )
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading,
                    expression: "loading",
                  },
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.page2Show,
                    expression: "page2Show",
                  },
                ],
                staticClass: "page-module",
                attrs: {
                  "element-loading-text": "加速生成中",
                  "element-loading-spinner": "el-icon-loading",
                  "element-loading-background": "rgba(0, 0, 0, 0.8)",
                },
              },
              [
                _c("div", { staticClass: "page-area" }, [
                  _c("div", { staticClass: "top-area" }, [
                    _c("div", { staticClass: "top-left-area" }, [
                      _c("span", { staticClass: "top-left-area-title" }, [
                        _vm._v("中国基金公司量化数据报告 "),
                      ]),
                      _c("span", { staticClass: "line-area" }, [_vm._v("|")]),
                      _c("span", { staticClass: "top-left-area-date" }, [
                        _vm._v(
                          "\n                                " +
                            _vm._s(_vm.companyReportData.quarterStr)
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _vm._m(44),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "page-limit-area" }, [
                    _vm.page2NewFundList.length != 0
                      ? _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.page2NewFundShow,
                                expression: "page2NewFundShow",
                              },
                            ],
                            ref: "page2NewFundRef",
                            staticStyle: { "margin-bottom": "10px" },
                          },
                          [
                            _c("div", { staticClass: "fixed-header" }, [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    "font-weight": "550",
                                    "font-size": "16px",
                                    display: "flex",
                                    width: "100%",
                                    height: "22px",
                                    color: "rgb(30, 30, 30)",
                                    "align-items": "center",
                                    padding: "6px 0px",
                                    "margin-top": "10px",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                                    新发基金(近一年)"
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "gm-row",
                                  staticStyle: {
                                    "font-size": "13px",
                                    color: "#1E1E1E",
                                    "font-weight": "550",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.newFund.length != 0,
                                          expression: "newFund.length != 0",
                                        },
                                      ],
                                      staticStyle: {
                                        display: "flex",
                                        flex: "1",
                                        "justify-content": "flex-start",
                                      },
                                    },
                                    [_vm._v("基金代码")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.newFund.length != 0,
                                          expression: "newFund.length != 0",
                                        },
                                      ],
                                      staticStyle: {
                                        display: "flex",
                                        flex: "4",
                                        "justify-content": "flex-start",
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "margin-left": "10px",
                                            "justify-content": "flex-start",
                                          },
                                        },
                                        [_vm._v("基金名称")]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.newFund.length != 0,
                                          expression: "newFund.length != 0",
                                        },
                                      ],
                                      staticStyle: {
                                        display: "flex",
                                        flex: "2",
                                        "justify-content": "flex-start",
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "justify-content": "flex-start",
                                            "margin-left": "10px",
                                          },
                                        },
                                        [_vm._v("首发基金经理")]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.newFund.length != 0,
                                          expression: "newFund.length != 0",
                                        },
                                      ],
                                      staticStyle: {
                                        display: "flex",
                                        flex: "2",
                                        "justify-content": "flex-start",
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "justify-content": "flex-start",
                                            "margin-left": "10px",
                                          },
                                        },
                                        [_vm._v("晨星分类")]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.newFund.length != 0,
                                          expression: "newFund.length != 0",
                                        },
                                      ],
                                      staticStyle: {
                                        display: "flex",
                                        flex: "2",
                                        "justify-content": "center",
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "margin-left": "8px",
                                          },
                                        },
                                        [_vm._v("成立日期")]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.newFund.length != 0,
                                          expression: "newFund.length != 0",
                                        },
                                      ],
                                      staticStyle: {
                                        display: "flex",
                                        flex: "1.5",
                                        "justify-content": "flex-end",
                                      },
                                    },
                                    [_vm._v("首发规模(亿元)")]
                                  ),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.page2NewFundList, function (item) {
                              return _c(
                                "div",
                                { key: item, staticClass: "gm-row" },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        flex: "1",
                                        "justify-content": "flex-start",
                                        "text-align": "left",
                                      },
                                    },
                                    [_vm._v(_vm._s(item.symbol))]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        flex: "4",
                                        "justify-content": "flex-start",
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "margin-left": "10px",
                                            "justify-content": "flex-start",
                                            "text-align": "left",
                                          },
                                        },
                                        [_vm._v(_vm._s(item.fundName))]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        flex: "2",
                                        "justify-content": "flex-start",
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "justify-content": "flex-start",
                                            "margin-left": "10px",
                                            "text-align": "left",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              item.managerName == ""
                                                ? "--"
                                                : item.managerName
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        flex: "2",
                                        "justify-content": "flex-start",
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "justify-content": "flex-start",
                                            "margin-left": "10px",
                                            "text-align": "left",
                                          },
                                        },
                                        [_vm._v(_vm._s(item.categoryName))]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        flex: "2",
                                        "justify-content": "center",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(item.inceptionDate.substr(0, 10))
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        flex: "1.5",
                                        "justify-content": "flex-end",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          item.fundSize == ""
                                            ? "--"
                                            : parseFloat(item.fundSize).toFixed(
                                                2
                                              )
                                        )
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            }),
                          ],
                          2
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.page2ObsoleteFundShow,
                            expression: "page2ObsoleteFundShow",
                          },
                        ],
                        ref: "page2ObsoleteFundRef",
                        staticClass: "cpct-area2",
                        staticStyle: { "border-top": "1.5px solid #b1b0b0" },
                      },
                      [
                        _c("div", { staticClass: "fixed-header" }, [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "font-weight": "550",
                                "font-size": "16px",
                                display: "flex",
                                width: "100%",
                                height: "28px",
                                color: "rgb(30, 30, 30)",
                                "align-items": "center",
                                padding: "6px 0px",
                                "margin-top": "10px",
                              },
                            },
                            [
                              _vm._v(
                                "\n                                    基金清盘(近一年)"
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "gm-row",
                              staticStyle: {
                                "font-size": "13px",
                                color: "#1E1E1E",
                                "font-weight": "550",
                              },
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    flex: "1",
                                    "justify-content": "flex-start",
                                  },
                                },
                                [_vm._v("基金代码")]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.obsoleteFund.length != 0,
                                      expression: "obsoleteFund.length != 0",
                                    },
                                  ],
                                  staticStyle: {
                                    display: "flex",
                                    flex: "4",
                                    "justify-content": "flex-start",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "margin-left": "10px",
                                        "justify-content": "flex-start",
                                      },
                                    },
                                    [_vm._v("基金名称")]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.obsoleteFund.length != 0,
                                      expression: "obsoleteFund.length != 0",
                                    },
                                  ],
                                  staticStyle: {
                                    display: "flex",
                                    flex: "2",
                                    "justify-content": "flex-start",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "justify-content": "flex-start",
                                        "margin-left": "10px",
                                      },
                                    },
                                    [_vm._v("基金经理")]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.obsoleteFund.length != 0,
                                      expression: "obsoleteFund.length != 0",
                                    },
                                  ],
                                  staticStyle: {
                                    display: "flex",
                                    flex: "2",
                                    "justify-content": "flex-start",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "justify-content": "flex-start",
                                        "margin-left": "10px",
                                      },
                                    },
                                    [_vm._v("晨星分类")]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.obsoleteFund.length != 0,
                                      expression: "obsoleteFund.length != 0",
                                    },
                                  ],
                                  staticStyle: {
                                    display: "flex",
                                    flex: "2",
                                    "justify-content": "center",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "margin-left": "8px",
                                      },
                                    },
                                    [_vm._v("成立日期")]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.obsoleteFund.length != 0,
                                      expression: "obsoleteFund.length != 0",
                                    },
                                  ],
                                  staticStyle: {
                                    display: "flex",
                                    flex: "1.5",
                                    "justify-content": "flex-end",
                                  },
                                },
                                [_vm._v("清盘日期")]
                              ),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _vm.page2ObsoleteFundList.length != 0
                          ? _c(
                              "div",
                              { staticStyle: { "margin-bottom": "10px" } },
                              _vm._l(
                                _vm.page2ObsoleteFundList,
                                function (item) {
                                  return _c(
                                    "div",
                                    { key: item, staticClass: "gm-row" },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            flex: "1",
                                            "justify-content": "flex-start",
                                            "text-align": "left",
                                          },
                                        },
                                        [_vm._v(_vm._s(item.symbol))]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            flex: "4",
                                            "justify-content": "flex-start",
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                display: "flex",
                                                "margin-left": "10px",
                                                "justify-content": "flex-start",
                                                "text-align": "left",
                                              },
                                            },
                                            [_vm._v(_vm._s(item.fundName))]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            flex: "2",
                                            "justify-content": "flex-start",
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                display: "flex",
                                                "justify-content": "flex-start",
                                                "margin-left": "10px",
                                                "text-align": "left",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  item.managerName == ""
                                                    ? "--"
                                                    : item.managerName
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            flex: "2",
                                            "justify-content": "flex-start",
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticStyle: {
                                                display: "flex",
                                                "justify-content": "flex-start",
                                                "margin-left": "10px",
                                                "text-align": "left",
                                              },
                                            },
                                            [_vm._v(_vm._s(item.categoryName))]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            flex: "2",
                                            "justify-content": "center",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              item.inceptionDate.substr(0, 10)
                                            )
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            flex: "1.5",
                                            "justify-content": "flex-end",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              item.obsoleteDate.substr(0, 10)
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                }
                              ),
                              0
                            )
                          : _c("div", [
                              _c("div", { staticClass: "null-node-area" }, [
                                _vm._v(
                                  "\n                                    暂无信息\n                                "
                                ),
                              ]),
                            ]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.page2MiniFundShow,
                            expression: "page2MiniFundShow",
                          },
                        ],
                        ref: "page2MiniFundRef",
                        staticClass: "cpct-area6",
                      },
                      [
                        _vm._m(45),
                        _vm._v(" "),
                        _vm._l(_vm.page2MiniFundList, function (item) {
                          return _c(
                            "div",
                            { key: item, staticClass: "gm-row" },
                            [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    flex: "1",
                                    "justify-content": "flex-start",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        width: "83px",
                                        "justify-content": "flex-start",
                                        "text-align": "left",
                                      },
                                    },
                                    [_vm._v(_vm._s(item.symbol))]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    flex: "7",
                                    "justify-content": "flex-start",
                                    "text-align": "left",
                                  },
                                },
                                [_vm._v(_vm._s(item.fundName))]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    flex: "3.5",
                                    "justify-content": "flex-start",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "justify-content": "flex-start",
                                        "margin-left": "5px",
                                        "text-align": "left",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          item.managerName == ""
                                            ? "--"
                                            : item.managerName
                                        )
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    flex: "3.8",
                                    "justify-content": "flex-start",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "justify-content": "flex-start",
                                        "margin-left": "10px",
                                        "text-align": "left",
                                      },
                                    },
                                    [_vm._v(_vm._s(item.categoryName))]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    flex: "2.5",
                                    "justify-content": "flex-end",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    { staticStyle: { "margin-right": "19px" } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          item.fundSize == ""
                                            ? "--"
                                            : parseFloat(item.fundSize).toFixed(
                                                2
                                              )
                                        )
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    flex: "1.5",
                                    "justify-content": "flex-end",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(item.index == true ? "是" : "否")
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    flex: "2",
                                    "justify-content": "flex-end",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(item.init == true ? "是" : "否")
                                  ),
                                ]
                              ),
                            ]
                          )
                        }),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c("div", {
                      ref: "flagHeightRef",
                      staticClass: "flag-height-class",
                      attrs: { id: "flag-height" },
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.page2FundCountShow,
                            expression: "page2FundCountShow",
                          },
                        ],
                        staticClass: "cpct-area3",
                      },
                      [
                        _c("div", { staticClass: "cpct-box3" }, [
                          _c(
                            "div",
                            {
                              staticClass: "gm-row2",
                              staticStyle: { width: "200px" },
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    flex: "2",
                                    "justify-content": "flex-start",
                                    "font-weight": "550",
                                  },
                                },
                                [_vm._v("基金数量")]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    flex: "1",
                                    "justify-content": "flex-end",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.companyIndexInfo.miniFundCount)
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "gm-row2",
                              staticStyle: { width: "200px" },
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    flex: "2",
                                    "justify-content": "flex-start",
                                    "font-weight": "550",
                                  },
                                },
                                [_vm._v("数量占比")]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    flex: "1",
                                    "justify-content": "flex-end",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.companyIndexInfo.miniFundCountRatio ==
                                        ""
                                        ? "--"
                                        : parseFloat(
                                            _vm.companyIndexInfo
                                              .miniFundCountRatio
                                          ).toFixed(2)
                                    ) + "%"
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "content-main3-area" }, [
                    _c("div", { staticClass: "bottom1-area" }, [
                      _c("span", { staticStyle: { "font-weight": "600" } }, [
                        _vm._v("数据来源："),
                      ]),
                      _c("span", [
                        _vm._v(
                          "Morningstar（晨星）；数据截⾄" +
                            _vm._s(_vm.companyReportData.latestDate) +
                            "，如⽆特殊说明以⼈⺠币计算。"
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _vm._m(46),
                  ]),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading,
                    expression: "loading",
                  },
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.page3Show,
                    expression: "page3Show",
                  },
                ],
                staticClass: "page-module",
                attrs: {
                  "element-loading-text": "加速生成中",
                  "element-loading-spinner": "el-icon-loading",
                  "element-loading-background": "rgba(0, 0, 0, 0.8)",
                },
              },
              [
                _c("div", { staticClass: "page-area" }, [
                  _c("div", { staticClass: "top-area" }, [
                    _c("div", { staticClass: "top-left-area" }, [
                      _c("span", { staticClass: "top-left-area-title" }, [
                        _vm._v("中国基金公司量化数据报告 "),
                      ]),
                      _c("span", { staticClass: "line-area" }, [_vm._v("|")]),
                      _c("span", { staticClass: "top-left-area-date" }, [
                        _vm._v(
                          "\n                                " +
                            _vm._s(_vm.companyReportData.quarterStr)
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _vm._m(47),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "page-limit-area" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.page3MiniFundShow,
                            expression: "page3MiniFundShow",
                          },
                        ],
                        staticClass: "cpct-area7",
                      },
                      [
                        _vm._m(48),
                        _vm._v(" "),
                        _vm._l(_vm.page3MiniFundList, function (item) {
                          return _c(
                            "div",
                            { key: item, staticClass: "gm-row" },
                            [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    flex: "1",
                                    "justify-content": "flex-start",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        width: "83px",
                                        "justify-content": "flex-start",
                                        "text-align": "left",
                                      },
                                    },
                                    [_vm._v(_vm._s(item.symbol))]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    flex: "7",
                                    "justify-content": "flex-start",
                                    "text-align": "left",
                                  },
                                },
                                [_vm._v(_vm._s(item.fundName))]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    flex: "3.5",
                                    "justify-content": "flex-start",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "justify-content": "flex-start",
                                        "margin-left": "5px",
                                        "text-align": "left",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          item.managerName == ""
                                            ? "--"
                                            : item.managerName
                                        )
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    flex: "3.8",
                                    "justify-content": "flex-start",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "justify-content": "flex-start",
                                        "margin-left": "10px",
                                        "text-align": "left",
                                      },
                                    },
                                    [_vm._v(_vm._s(item.categoryName))]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    flex: "2.5",
                                    "justify-content": "flex-end",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    { staticStyle: { "margin-right": "19px" } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          item.fundSize == ""
                                            ? "--"
                                            : parseFloat(item.fundSize).toFixed(
                                                2
                                              )
                                        )
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    flex: "1.5",
                                    "justify-content": "flex-end",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(item.index == true ? "是" : "否")
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    flex: "2",
                                    "justify-content": "flex-end",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(item.init == true ? "是" : "否")
                                  ),
                                ]
                              ),
                            ]
                          )
                        }),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.page3FundCountShow,
                            expression: "page3FundCountShow",
                          },
                        ],
                        staticClass: "cpct-area3",
                      },
                      [
                        _c("div", { staticClass: "cpct-box3" }, [
                          _c(
                            "div",
                            {
                              staticClass: "gm-row2",
                              staticStyle: { width: "200px" },
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    flex: "2",
                                    "justify-content": "flex-start",
                                    "font-weight": "550",
                                  },
                                },
                                [_vm._v("基金数量")]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    flex: "1",
                                    "justify-content": "flex-end",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.companyIndexInfo.miniFundCount)
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "gm-row2",
                              staticStyle: { width: "200px" },
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    flex: "2",
                                    "justify-content": "flex-start",
                                    "font-weight": "550",
                                  },
                                },
                                [_vm._v("数量占比")]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    flex: "1",
                                    "justify-content": "flex-end",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.companyIndexInfo.miniFundCountRatio
                                    ) + "%"
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "content-main3-area" }, [
                    _c("div", { staticClass: "bottom1-area" }, [
                      _c("span", { staticStyle: { "font-weight": "600" } }, [
                        _vm._v("数据来源："),
                      ]),
                      _c("span", [
                        _vm._v(
                          "Morningstar（晨星）；数据截⾄" +
                            _vm._s(_vm.companyReportData.latestDate) +
                            "，如⽆特殊说明以⼈⺠币计算。"
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _vm._m(49),
                  ]),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading,
                    expression: "loading",
                  },
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.page4Show,
                    expression: "page4Show",
                  },
                ],
                staticClass: "page-module",
                attrs: {
                  "element-loading-text": "加速生成中",
                  "element-loading-spinner": "el-icon-loading",
                  "element-loading-background": "rgba(0, 0, 0, 0.8)",
                },
              },
              [
                _c("div", { staticClass: "page-area" }, [
                  _c("div", { staticClass: "top-area" }, [
                    _c("div", { staticClass: "top-left-area" }, [
                      _c("span", { staticClass: "top-left-area-title" }, [
                        _vm._v("中国基金公司量化数据报告 "),
                      ]),
                      _c("span", { staticClass: "line-area" }, [_vm._v("|")]),
                      _c("span", { staticClass: "top-left-area-date" }, [
                        _vm._v(
                          "\n                                " +
                            _vm._s(_vm.companyReportData.quarterStr)
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _vm._m(50),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "page-limit-area" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.page4MiniFundShow,
                            expression: "page4MiniFundShow",
                          },
                        ],
                        staticClass: "cpct-area7",
                      },
                      [
                        _vm._m(51),
                        _vm._v(" "),
                        _vm._l(_vm.page4MiniFundList, function (item) {
                          return _c(
                            "div",
                            { key: item, staticClass: "gm-row" },
                            [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    flex: "1",
                                    "justify-content": "flex-start",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        width: "83px",
                                        "justify-content": "flex-start",
                                        "text-align": "left",
                                      },
                                    },
                                    [_vm._v(_vm._s(item.symbol))]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    flex: "7",
                                    "justify-content": "flex-start",
                                    "text-align": "left",
                                  },
                                },
                                [_vm._v(_vm._s(item.fundName))]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    flex: "3.5",
                                    "justify-content": "flex-start",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "justify-content": "flex-start",
                                        "margin-left": "5px",
                                        "text-align": "left",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          item.managerName == ""
                                            ? "--"
                                            : item.managerName
                                        )
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    flex: "3.8",
                                    "justify-content": "flex-start",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "justify-content": "flex-start",
                                        "margin-left": "10px",
                                        "text-align": "left",
                                      },
                                    },
                                    [_vm._v(_vm._s(item.categoryName))]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    flex: "2.5",
                                    "justify-content": "flex-end",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    { staticStyle: { "margin-right": "19px" } },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          item.fundSize == ""
                                            ? "--"
                                            : parseFloat(item.fundSize).toFixed(
                                                2
                                              )
                                        )
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    flex: "1.5",
                                    "justify-content": "flex-end",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(item.index == true ? "是" : "否")
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    flex: "2",
                                    "justify-content": "flex-end",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(item.init == true ? "是" : "否")
                                  ),
                                ]
                              ),
                            ]
                          )
                        }),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.page4FundCountShow,
                            expression: "page4FundCountShow",
                          },
                        ],
                        staticClass: "cpct-area3",
                      },
                      [
                        _c("div", { staticClass: "cpct-box3" }, [
                          _c(
                            "div",
                            {
                              staticClass: "gm-row2",
                              staticStyle: { width: "200px" },
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    flex: "2",
                                    "justify-content": "flex-start",
                                    "font-weight": "550",
                                  },
                                },
                                [_vm._v("基金数量")]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    flex: "1",
                                    "justify-content": "flex-end",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.companyIndexInfo.miniFundCount)
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "gm-row2",
                              staticStyle: { width: "200px" },
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    flex: "2",
                                    "justify-content": "flex-start",
                                    "font-weight": "550",
                                  },
                                },
                                [_vm._v("数量占比")]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    flex: "1",
                                    "justify-content": "flex-end",
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.companyIndexInfo.miniFundCountRatio
                                    ) + "%"
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "content-main3-area" }, [
                    _c("div", { staticClass: "bottom1-area" }, [
                      _c("span", { staticStyle: { "font-weight": "600" } }, [
                        _vm._v("数据来源："),
                      ]),
                      _c("span", [
                        _vm._v(
                          "Morningstar（晨星）；数据截⾄" +
                            _vm._s(_vm.companyReportData.latestDate) +
                            "，如⽆特殊说明以⼈⺠币计算。"
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _vm._m(52),
                  ]),
                ]),
              ]
            ),
          ],
          2
        ),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "top-right-area" }, [
      _c("div", { staticClass: "top-right-area-img" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          display: "flex",
          flex: "1",
          "justify-content": "space-between",
          "align-items": "center",
        },
      },
      [
        _c(
          "span",
          {
            staticStyle: {
              "font-weight": "600",
              "font-size": "13px",
              color: "black",
            },
          },
          [_vm._v("旗下基金经理统计")]
        ),
        _vm._v(" "),
        _c(
          "span",
          {
            staticStyle: {
              "font-weight": "600",
              "font-size": "13px",
              color: "black",
            },
          },
          [_vm._v("排名")]
        ),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      {
        staticStyle: {
          display: "flex",
          flex: "1",
          "font-weight": "545",
          "font-size": "14px",
        },
      },
      [
        _c("span", { staticStyle: { display: "flex", width: "140px" } }, [
          _vm._v("人数"),
        ]),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      {
        staticStyle: {
          display: "flex",
          flex: "1",
          "font-weight": "545",
          "font-size": "14px",
        },
      },
      [
        _c("span", { staticStyle: { display: "flex", width: "140px" } }, [
          _vm._v("平均投管经验（年）"),
        ]),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      {
        staticStyle: {
          display: "flex",
          flex: "1",
          "font-weight": "545",
          "font-size": "14px",
        },
      },
      [
        _c("span", { staticStyle: { display: "flex", width: "140px" } }, [
          _vm._v("平均在职时长（年）"),
        ]),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "span",
      {
        staticStyle: {
          display: "flex",
          flex: "1",
          "font-weight": "545",
          "font-size": "14px",
        },
      },
      [
        _c("span", { staticStyle: { display: "flex", width: "140px" } }, [
          _vm._v("最近三年留职率"),
        ]),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "left-bottom-area33-box" }, [
      _c("div", { staticClass: "left-bottom-area33-box1" }, [
        _c(
          "span",
          { staticStyle: { "margin-bottom": "3px", "font-size": "10px" } },
          [_vm._v("规模占比")]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "left-bottom-area33-box2" }, [
        _c(
          "span",
          { staticStyle: { "margin-top": "3px", "font-size": "10px" } },
          [_vm._v("数量(只)")]
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "box-bottom5" }, [
      _c("div", { staticClass: "star5" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "box-bottom4" }, [
      _c("div", { staticClass: "star4" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "box-bottom3" }, [
      _c("div", { staticClass: "star3" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "box-bottom2" }, [
      _c("div", { staticClass: "star2" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "box-bottom1" }, [
      _c("div", { staticClass: "star1" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "top-box-area1" }, [
      _c(
        "span",
        {
          staticStyle: {
            display: "flex",
            "justify-content": "flex-end",
            flex: "1.7",
            "margin-left": "40px",
          },
        },
        [
          _c(
            "span",
            {
              staticStyle: {
                display: "flex",
                "font-size": "13px",
                color: "black",
              },
            },
            [_vm._v("参评基金数量")]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          staticStyle: {
            display: "flex",
            flex: "1.5",
            "justify-content": "center",
            "margin-left": "18px",
          },
        },
        [
          _c(
            "span",
            {
              staticStyle: {
                display: "flex",
                "font-size": "13px",
                color: "black",
              },
            },
            [_vm._v("规模分类")]
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          staticStyle: {
            display: "flex",
            flex: "1.1",
            "justify-content": "center",
          },
        },
        [
          _c(
            "span",
            {
              staticStyle: {
                display: "flex",
                "font-size": "13px",
                color: "black",
              },
            },
            [_vm._v("排名")]
          ),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticStyle: { display: "flex", flex: "5.1" } }, [
        _c("span", { staticStyle: { display: "flex", flex: "1" } }, [
          _c(
            "span",
            {
              staticStyle: {
                display: "flex",
                "font-size": "13px",
                color: "black",
              },
            },
            [_vm._v("总分值")]
          ),
        ]),
        _vm._v(" "),
        _c(
          "span",
          {
            staticStyle: {
              display: "flex",
              flex: "1",
              "justify-content": "flex-end",
            },
          },
          [
            _c("span", {
              staticStyle: {
                display: "flex",
                width: "12px",
                height: "12px",
                "margin-top": "3px",
                "margin-right": "6px",
                "border-radius": "50%",
                "background-color": "#1F55A5",
              },
            }),
            _vm._v(" "),
            _c(
              "span",
              {
                staticStyle: {
                  display: "flex",
                  "font-size": "13px",
                  color: "black",
                },
              },
              [_vm._v("得分")]
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "span",
          {
            staticStyle: {
              display: "flex",
              flex: "1.5",
              "justify-content": "flex-end",
            },
          },
          [
            _c("span", {
              staticStyle: {
                display: "flex",
                width: "2px",
                height: "14px",
                "margin-top": "2px",
                "margin-right": "6px",
                "background-color": "#060000",
              },
            }),
            _vm._v(" "),
            _c(
              "span",
              {
                staticStyle: {
                  display: "flex",
                  "font-size": "13px",
                  color: "black",
                },
              },
              [_vm._v("中位数")]
            ),
          ]
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "num-area" }, [
      _c("div", { staticClass: "num-box1" }, [_vm._v("0")]),
      _vm._v(" "),
      _c("div", { staticClass: "num-box2" }, [_vm._v("20")]),
      _vm._v(" "),
      _c("div", { staticClass: "num-box3" }, [_vm._v("40")]),
      _vm._v(" "),
      _c("div", { staticClass: "num-box4" }, [_vm._v("60")]),
      _vm._v(" "),
      _c("div", { staticClass: "num-box5" }, [_vm._v("80")]),
      _vm._v(" "),
      _c("div", { staticClass: "num-box6" }, [_vm._v("100")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "xc-top-box" }, [
      _c("div", { staticClass: "top-right" }, [
        _c(
          "div",
          {
            staticClass: "top-title",
            staticStyle: {
              display: "flex",
              flex: "6",
              "font-size": "13px",
              "font-weight": "550",
              "justify-content": "flex-end",
              color: "black",
            },
          },
          [
            _vm._v(
              "\n                                                    幸存率"
            ),
            _c(
              "span",
              {
                staticStyle: {
                  color: "rgb(161 161 161)",
                  "font-weight": "200",
                },
              },
              [_vm._v("/同类平均")]
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "top-three",
            staticStyle: {
              display: "flex",
              flex: "2",
              "font-size": "13px",
              "justify-content": "flex-end",
              "font-weight": "550",
              color: "black",
            },
          },
          [_vm._v("\n                                                    排名")]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "top-five",
            staticStyle: {
              display: "flex",
              flex: "5",
              "font-size": "13px",
              "justify-content": "flex-end",
              "font-weight": "550",
              color: "black",
            },
          },
          [
            _vm._v(
              "\n                                                    成功率"
            ),
            _c(
              "span",
              {
                staticStyle: {
                  color: "rgb(161 161 161)",
                  "font-weight": "200",
                },
              },
              [_vm._v("/同类平均")]
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "top-ten",
            staticStyle: {
              display: "flex",
              flex: "2",
              "font-size": "13px",
              "justify-content": "flex-end",
              "font-weight": "550",
              color: "black",
            },
          },
          [_vm._v("\n                                                    排名")]
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "top-left" }, [
      _c(
        "div",
        {
          staticClass: "top-title",
          staticStyle: {
            display: "flex",
            flex: "3",
            "font-size": "13px",
            color: "black",
          },
        },
        [_vm._v("三年\n                                                    ")]
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "top-left" }, [
      _c(
        "div",
        {
          staticClass: "top-title",
          staticStyle: {
            display: "flex",
            flex: "3",
            "font-size": "13px",
            color: "black",
          },
        },
        [_vm._v("五年\n                                                    ")]
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "top-left" }, [
      _c(
        "div",
        {
          staticClass: "top-title",
          staticStyle: {
            display: "flex",
            flex: "3",
            "font-size": "13px",
            color: "black",
          },
        },
        [_vm._v("十年\n                                                    ")]
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "gm-left-title" }, [
      _c(
        "span",
        {
          staticStyle: {
            display: "flex",
            flex: "3",
            "justify-content": "flex-start",
            color: "black",
          },
        },
        [_vm._v("非货币基金")]
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          staticStyle: {
            display: "flex",
            flex: "1",
            "justify-content": "flex-end",
            color: "black",
          },
        },
        [_vm._v("数值")]
      ),
      _vm._v(" "),
      _c(
        "span",
        {
          staticStyle: {
            display: "flex",
            flex: "1",
            "justify-content": "flex-end",
            color: "black",
          },
        },
        [_vm._v("排名")]
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cpx-data-row" }, [
      _c("div", { staticClass: "cpx-row", staticStyle: { display: "flex" } }, [
        _c("span", { staticStyle: { display: "flex", flex: "1" } }),
        _vm._v(" "),
        _c(
          "span",
          {
            staticStyle: {
              display: "flex",
              flex: "1",
              "font-size": "13px",
              "font-weight": "550",
              "justify-content": "flex-end",
              color: "black",
            },
          },
          [_vm._v("规模(亿元)")]
        ),
        _vm._v(" "),
        _c(
          "span",
          {
            staticStyle: {
              display: "flex",
              flex: "1",
              "font-size": "13px",
              "font-weight": "550",
              "justify-content": "flex-end",
              color: "black",
            },
          },
          [_vm._v("排名")]
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "circle-div" }, [
      _c("div", { staticClass: "process-circle-big1" }, [
        _c("div", { staticClass: "process-circle-small" }),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "circle-div" }, [
      _c("div", { staticClass: "process-circle-big2" }, [
        _c("div", { staticClass: "process-circle-small" }),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "circle-div" }, [
      _c("div", { staticClass: "process-circle-big3" }, [
        _c("div", { staticClass: "process-circle-small" }),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "circle-div" }, [
      _c("div", { staticClass: "process-circle-big4" }, [
        _c("div", { staticClass: "process-circle-small" }),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "circle-div" }, [
      _c("div", { staticClass: "process-circle-big5" }, [
        _c("div", { staticClass: "process-circle-small" }),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cpx-data-row2" }, [
      _c("div", { staticClass: "cpx-row", staticStyle: { display: "flex" } }, [
        _c("span", { staticStyle: { display: "flex", flex: "1" } }),
        _vm._v(" "),
        _c(
          "span",
          {
            staticStyle: {
              display: "flex",
              flex: "1",
              "font-size": "13px",
              "font-weight": "550",
              "justify-content": "flex-end",
              color: "black",
            },
          },
          [_vm._v("规模(亿元)")]
        ),
        _vm._v(" "),
        _c(
          "span",
          {
            staticStyle: {
              display: "flex",
              flex: "1",
              "font-size": "13px",
              "font-weight": "550",
              "justify-content": "flex-end",
              color: "black",
            },
          },
          [_vm._v("排名")]
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticStyle: { display: "flex", flex: "1" } }, [
      _c("span", { staticStyle: { display: "flex" } }, [_vm._v("指数增强型")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "circle-div6" }, [
      _c("div", { staticClass: "process-circle-big33" }, [
        _c("div", { staticClass: "process-circle-small6" }),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "circle-div6" }, [
      _c("div", { staticClass: "process-circle-big22" }, [
        _c("div", { staticClass: "process-circle-small6" }),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "fl-content-area1" }, [
      _c("div", { staticClass: "fl-content-title" }),
      _vm._v(" "),
      _c("div", { staticClass: "fl-content-data" }, [_vm._v("运营费率")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "bottom2-area" }, [
      _c("span", { staticStyle: { "font-weight": "600" } }, [
        _vm._v("免责声明："),
      ]),
      _c("span", [
        _vm._v(
          "晨星（Morningstar）不保证信息的准确性、完整性和及时性，同时也不保证不会发⽣任何变更。此资料、数据、观点仅供参考，并不构成投资建议。在任何情况\n                                下，我公司不就本报告中的任何内容对任何投资⾏为做出任何形式的担保。基⾦过往业绩并不预示其未来表现，市场有⻛险，投资需谨慎。本报告内容的版权归晨星资讯（深\n                                圳）有限公司所有，未获得书⾯授权许可，不得以任何形式复制或⽤于制作报告、⽂件等⽤途。"
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "top-right-area" }, [
      _c("div", { staticClass: "top-right-area-img" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "gm-row", staticStyle: { padding: "6px 0px" } },
      [
        _c(
          "span",
          {
            staticStyle: {
              display: "flex",
              flex: "1",
              "justify-content": "flex-end",
              "font-weight": "550",
              "font-size": "14px",
              color: "rgb(30, 30, 30)",
            },
          },
          [_vm._v("排名")]
        ),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "gm-row",
        staticStyle: {
          "font-size": "14px",
          color: "#1E1E1E",
          padding: "6px 0px",
          "font-weight": "550",
        },
      },
      [
        _c(
          "span",
          {
            staticStyle: {
              display: "flex",
              flex: "5",
              "justify-content": "flex-start",
            },
          },
          [_vm._v("资金流入前三")]
        ),
        _vm._v(" "),
        _c(
          "span",
          {
            staticStyle: {
              display: "flex",
              flex: "1",
              "justify-content": "flex-end",
              "font-size": "13px",
            },
          },
          [_vm._v("基金代码")]
        ),
        _vm._v(" "),
        _c(
          "span",
          {
            staticStyle: {
              display: "flex",
              flex: "2.5",
              "justify-content": "flex-end",
              "font-size": "13px",
            },
          },
          [_vm._v("季度资金流变化(亿元)")]
        ),
        _vm._v(" "),
        _c(
          "span",
          {
            staticStyle: {
              display: "flex",
              flex: "2",
              "justify-content": "flex-end",
              "font-size": "13px",
            },
          },
          [_vm._v("最新规模(亿元)")]
        ),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "gm-row",
        staticStyle: {
          "font-size": "14px",
          color: "#1E1E1E",
          padding: "6px 0px",
          "font-weight": "550",
        },
      },
      [
        _c(
          "span",
          {
            staticStyle: {
              display: "flex",
              flex: "5",
              "justify-content": "flex-start",
            },
          },
          [_vm._v("资金流出前三")]
        ),
        _vm._v(" "),
        _c(
          "span",
          {
            staticStyle: {
              display: "flex",
              flex: "1",
              "justify-content": "flex-end",
              "font-size": "13px",
            },
          },
          [_vm._v("基金代码")]
        ),
        _vm._v(" "),
        _c(
          "span",
          {
            staticStyle: {
              display: "flex",
              flex: "2.5",
              "justify-content": "flex-end",
              "font-size": "13px",
            },
          },
          [_vm._v("季度资金流变化(亿元)")]
        ),
        _vm._v(" "),
        _c(
          "span",
          {
            staticStyle: {
              display: "flex",
              flex: "2",
              "justify-content": "flex-end",
              "font-size": "13px",
            },
          },
          [_vm._v("最新规模(亿元)")]
        ),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "fixed-header" }, [
      _c(
        "div",
        {
          staticStyle: {
            "font-weight": "550",
            "font-size": "16px",
            display: "flex",
            width: "100%",
            height: "22px",
            color: "rgb(30, 30, 30)",
            "align-items": "center",
            padding: "6px 0px",
            "margin-top": "10px",
          },
        },
        [
          _vm._v(
            "\n                                        新发基金(近一年)\n                                        "
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "gm-row",
          staticStyle: {
            "font-size": "13px",
            color: "#1E1E1E",
            "font-weight": "550",
          },
        },
        [
          _c(
            "span",
            {
              staticStyle: {
                display: "flex",
                flex: "1",
                "justify-content": "flex-start",
              },
            },
            [_vm._v("基金代码")]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticStyle: {
                display: "flex",
                flex: "4",
                "justify-content": "flex-start",
              },
            },
            [
              _c(
                "span",
                {
                  staticStyle: {
                    display: "flex",
                    "margin-left": "10px",
                    "justify-content": "flex-start",
                  },
                },
                [_vm._v("基金名称")]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticStyle: {
                display: "flex",
                flex: "2",
                "justify-content": "flex-start",
              },
            },
            [
              _c(
                "span",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "flex-start",
                    "margin-left": "10px",
                  },
                },
                [_vm._v("首发基金经理")]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticStyle: {
                display: "flex",
                flex: "2",
                "justify-content": "flex-start",
              },
            },
            [
              _c(
                "span",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "flex-start",
                    "margin-left": "10px",
                  },
                },
                [_vm._v("晨星分类")]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticStyle: {
                display: "flex",
                flex: "2",
                "justify-content": "center",
              },
            },
            [
              _c(
                "span",
                { staticStyle: { display: "flex", "margin-left": "8px" } },
                [_vm._v("成立日期")]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticStyle: {
                display: "flex",
                flex: "1.5",
                "justify-content": "flex-end",
              },
            },
            [_vm._v("首发规模(亿元)")]
          ),
        ]
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "fixed-header" }, [
      _c(
        "div",
        {
          staticStyle: {
            "font-weight": "550",
            "font-size": "16px",
            display: "flex",
            width: "100%",
            height: "28px",
            color: "rgb(30, 30, 30)",
            "align-items": "center",
            padding: "6px 0px",
            "margin-top": "10px",
          },
        },
        [
          _vm._v(
            "\n                                    基金清盘(近一年)\n                                    "
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "gm-row",
          staticStyle: {
            "font-size": "13px",
            color: "#1E1E1E",
            "font-weight": "550",
          },
        },
        [
          _c(
            "span",
            {
              staticStyle: {
                display: "flex",
                flex: "1",
                "justify-content": "flex-start",
              },
            },
            [_vm._v("基金代码")]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticStyle: {
                display: "flex",
                flex: "4",
                "justify-content": "flex-start",
              },
            },
            [
              _c(
                "span",
                {
                  staticStyle: {
                    display: "flex",
                    "margin-left": "10px",
                    "justify-content": "flex-start",
                  },
                },
                [_vm._v("基金名称")]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticStyle: {
                display: "flex",
                flex: "2",
                "justify-content": "flex-start",
              },
            },
            [
              _c(
                "span",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "flex-start",
                    "margin-left": "10px",
                  },
                },
                [_vm._v("基金经理")]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticStyle: {
                display: "flex",
                flex: "2",
                "justify-content": "flex-start",
              },
            },
            [
              _c(
                "span",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "flex-start",
                    "margin-left": "10px",
                  },
                },
                [_vm._v("晨星分类")]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticStyle: {
                display: "flex",
                flex: "2",
                "justify-content": "center",
              },
            },
            [
              _c(
                "span",
                { staticStyle: { display: "flex", "margin-left": "8px" } },
                [_vm._v("成立日期")]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticStyle: {
                display: "flex",
                flex: "1.5",
                "justify-content": "flex-end",
              },
            },
            [_vm._v("清盘日期")]
          ),
        ]
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "fixed-header" }, [
      _c(
        "div",
        {
          staticStyle: {
            "font-weight": "550",
            "font-size": "16px",
            display: "flex",
            width: "100%",
            height: "22px",
            color: "rgb(30, 30, 30)",
            "align-items": "center",
            padding: "6px 0px",
            "margin-top": "10px",
          },
        },
        [
          _vm._v(
            "\n                                        迷你基金(规模不足一亿)"
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "gm-row3",
          staticStyle: {
            "font-size": "13px",
            color: "#1E1E1E",
            "font-weight": "550",
          },
        },
        [
          _c(
            "span",
            {
              staticStyle: {
                display: "flex",
                flex: "1",
                "justify-content": "flex-start",
              },
            },
            [
              _c(
                "span",
                {
                  staticStyle: {
                    display: "flex",
                    width: "83px",
                    "justify-content": "flex-start",
                  },
                },
                [_vm._v("基金代码")]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticStyle: {
                display: "flex",
                flex: "7",
                "justify-content": "flex-start",
              },
            },
            [_vm._v("基金名称")]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticStyle: {
                display: "flex",
                flex: "3.5",
                "justify-content": "flex-start",
              },
            },
            [
              _c(
                "span",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "flex-start",
                    "margin-left": "5px",
                  },
                },
                [_vm._v("基金经理")]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticStyle: {
                display: "flex",
                flex: "3.8",
                "justify-content": "flex-start",
              },
            },
            [
              _c(
                "span",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "flex-start",
                    "margin-left": "10px",
                  },
                },
                [_vm._v("晨星分类")]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticStyle: {
                display: "flex",
                flex: "2.5",
                "justify-content": "flex-start",
              },
            },
            [_vm._v("最新规模(亿元)")]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticStyle: {
                display: "flex",
                flex: "1.5",
                "justify-content": "flex-end",
              },
            },
            [_vm._v("是否指数")]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticStyle: {
                display: "flex",
                flex: "2",
                "justify-content": "flex-end",
              },
            },
            [_vm._v("是否发起式")]
          ),
        ]
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "bottom2-area" }, [
      _c("span", { staticStyle: { "font-weight": "600" } }, [
        _vm._v("免责声明："),
      ]),
      _c("span", [
        _vm._v(
          "晨星（Morningstar）不保证信息的准确性、完整性和及时性，同时也不保证不会发⽣任何变更。此资料、数据、观点仅供参考，并不构成投资建议。在任何情况\n                                下，我公司不就本报告中的任何内容对任何投资⾏为做出任何形式的担保。基⾦过往业绩并不预示其未来表现，市场有⻛险，投资需谨慎。本报告内容的版权归晨星资讯（深\n                                圳）有限公司所有，未获得书⾯授权许可，不得以任何形式复制或⽤于制作报告、⽂件等⽤途。"
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "gm-row fund-standard-row fund-table-header" },
      [
        _c("span", [_vm._v("基金代码")]),
        _c("span", [_vm._v("基金名称")]),
        _c("span", [_vm._v("首发基金经理")]),
        _vm._v(" "),
        _c("span", [_vm._v("晨星分类")]),
        _c("span", [_vm._v("成立日期")]),
        _c("span", [_vm._v("首发规模(亿元)")]),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "gm-row fund-standard-row fund-table-header" },
      [
        _c("span", [_vm._v("基金代码")]),
        _c("span", [_vm._v("基金名称")]),
        _c("span", [_vm._v("基金经理")]),
        _vm._v(" "),
        _c("span", [_vm._v("晨星分类")]),
        _c("span", [_vm._v("成立日期")]),
        _c("span", [_vm._v("清盘日期")]),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "gm-row3 fund-mini-row fund-table-header" },
      [
        _c("span", [_vm._v("基金代码")]),
        _c("span", [_vm._v("基金名称")]),
        _c("span", [_vm._v("基金经理")]),
        _c("span", [_vm._v("晨星分类")]),
        _vm._v(" "),
        _c("span", [_vm._v("最新规模(亿元)")]),
        _c("span", [_vm._v("是否指数")]),
        _c("span", [_vm._v("是否发起式")]),
      ]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "top-right-area" }, [
      _c("div", { staticClass: "top-right-area-img" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "bottom2-area" }, [
      _c("span", { staticStyle: { "font-weight": "600" } }, [
        _vm._v("免责声明："),
      ]),
      _c("span", [
        _vm._v(
          "晨星（Morningstar）不保证信息的准确性、完整性和及时性，同时也不保证不会发⽣任何变更。此资料、数据、观点仅供参考，并不构成投资建议。在任何情况下，我公司不就本报告中的任何内容对任何投资⾏为做出任何形式的担保。基⾦过往业绩并不预示其未来表现，市场有⻛险，投资需谨慎。本报告内容的版权归晨星资讯（深圳）有限公司所有，未获得书⾯授权许可，不得以任何形式复制或⽤于制作报告、⽂件等⽤途。"
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "top-right-area" }, [
      _c("div", { staticClass: "top-right-area-img" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "fixed-header" }, [
      _c(
        "div",
        {
          staticStyle: {
            "font-weight": "550",
            "font-size": "16px",
            display: "flex",
            width: "100%",
            height: "22px",
            color: "rgb(30, 30, 30)",
            "align-items": "center",
            padding: "6px 0px",
            "margin-top": "10px",
          },
        },
        [_vm._v("\n                                    迷你基金(规模不足一亿)")]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "gm-row",
          staticStyle: {
            "font-size": "13px",
            color: "#1E1E1E",
            "font-weight": "550",
          },
        },
        [
          _c(
            "span",
            {
              staticStyle: {
                display: "flex",
                flex: "1",
                "justify-content": "flex-start",
              },
            },
            [
              _c(
                "span",
                {
                  staticStyle: {
                    display: "flex",
                    width: "83px",
                    "justify-content": "flex-start",
                  },
                },
                [_vm._v("基金代码")]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticStyle: {
                display: "flex",
                flex: "7",
                "justify-content": "flex-start",
              },
            },
            [_vm._v("基金名称")]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticStyle: {
                display: "flex",
                flex: "3.5",
                "justify-content": "flex-start",
              },
            },
            [
              _c(
                "span",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "flex-start",
                    "margin-left": "5px",
                  },
                },
                [_vm._v("基金经理")]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticStyle: {
                display: "flex",
                flex: "3.8",
                "justify-content": "flex-start",
              },
            },
            [
              _c(
                "span",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "flex-start",
                    "margin-left": "10px",
                  },
                },
                [_vm._v("晨星分类")]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticStyle: {
                display: "flex",
                flex: "2.5",
                "justify-content": "flex-start",
              },
            },
            [_vm._v("最新规模(亿元)")]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticStyle: {
                display: "flex",
                flex: "1.5",
                "justify-content": "flex-end",
              },
            },
            [_vm._v("是否指数")]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticStyle: {
                display: "flex",
                flex: "2",
                "justify-content": "flex-end",
              },
            },
            [_vm._v("是否发起式")]
          ),
        ]
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "bottom2-area" }, [
      _c("span", { staticStyle: { "font-weight": "600" } }, [
        _vm._v("免责声明："),
      ]),
      _c("span", [
        _vm._v(
          "晨星（Morningstar）不保证信息的准确性、完整性和及时性，同时也不保证不会发⽣任何变更。此资料、数据、观点仅供参考，并不构成投资建议。在任何情况\n                                下，我公司不就本报告中的任何内容对任何投资⾏为做出任何形式的担保。基⾦过往业绩并不预示其未来表现，市场有⻛险，投资需谨慎。本报告内容的版权归晨星资讯（深\n                                圳）有限公司所有，未获得书⾯授权许可，不得以任何形式复制或⽤于制作报告、⽂件等⽤途。"
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "top-right-area" }, [
      _c("div", { staticClass: "top-right-area-img" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "fixed-header" }, [
      _c(
        "div",
        {
          staticStyle: {
            "font-weight": "550",
            "font-size": "16px",
            display: "flex",
            width: "100%",
            height: "22px",
            color: "rgb(30, 30, 30)",
            "align-items": "center",
            padding: "6px 0px",
            "margin-top": "10px",
          },
        },
        [_vm._v("\n                                    迷你基金(规模不足一亿)")]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "gm-row",
          staticStyle: {
            "font-size": "13px",
            color: "#1E1E1E",
            "font-weight": "550",
          },
        },
        [
          _c(
            "span",
            {
              staticStyle: {
                display: "flex",
                flex: "1",
                "justify-content": "flex-start",
              },
            },
            [
              _c(
                "span",
                {
                  staticStyle: {
                    display: "flex",
                    width: "83px",
                    "justify-content": "flex-start",
                  },
                },
                [_vm._v("基金代码")]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticStyle: {
                display: "flex",
                flex: "7",
                "justify-content": "flex-start",
              },
            },
            [_vm._v("基金名称")]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticStyle: {
                display: "flex",
                flex: "3.5",
                "justify-content": "flex-start",
              },
            },
            [
              _c(
                "span",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "flex-start",
                    "margin-left": "5px",
                  },
                },
                [_vm._v("基金经理")]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticStyle: {
                display: "flex",
                flex: "3.8",
                "justify-content": "flex-start",
              },
            },
            [
              _c(
                "span",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "flex-start",
                    "margin-left": "10px",
                  },
                },
                [_vm._v("晨星分类")]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticStyle: {
                display: "flex",
                flex: "2.5",
                "justify-content": "flex-start",
              },
            },
            [_vm._v("最新规模(亿元)")]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticStyle: {
                display: "flex",
                flex: "1.5",
                "justify-content": "flex-end",
              },
            },
            [_vm._v("是否指数")]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticStyle: {
                display: "flex",
                flex: "2",
                "justify-content": "flex-end",
              },
            },
            [_vm._v("是否发起式")]
          ),
        ]
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "bottom2-area" }, [
      _c("span", { staticStyle: { "font-weight": "600" } }, [
        _vm._v("免责声明："),
      ]),
      _c("span", [
        _vm._v(
          "晨星（Morningstar）不保证信息的准确性、完整性和及时性，同时也不保证不会发⽣任何变更。此资料、数据、观点仅供参考，并不构成投资建议。在任何情况\n                                下，我公司不就本报告中的任何内容对任何投资⾏为做出任何形式的担保。基⾦过往业绩并不预示其未来表现，市场有⻛险，投资需谨慎。本报告内容的版权归晨星资讯（深\n                                圳）有限公司所有，未获得书⾯授权许可，不得以任何形式复制或⽤于制作报告、⽂件等⽤途。"
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "top-right-area" }, [
      _c("div", { staticClass: "top-right-area-img" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "fixed-header" }, [
      _c(
        "div",
        {
          staticStyle: {
            "font-weight": "550",
            "font-size": "16px",
            display: "flex",
            width: "100%",
            height: "22px",
            color: "rgb(30, 30, 30)",
            "align-items": "center",
            padding: "6px 0px",
          },
        },
        [_vm._v("\n                                    迷你基金(规模不足一亿)")]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "gm-row",
          staticStyle: {
            "font-size": "13px",
            color: "#1E1E1E",
            "font-weight": "550",
          },
        },
        [
          _c(
            "span",
            {
              staticStyle: {
                display: "flex",
                flex: "1",
                "justify-content": "flex-start",
              },
            },
            [
              _c(
                "span",
                {
                  staticStyle: {
                    display: "flex",
                    width: "83px",
                    "justify-content": "flex-start",
                  },
                },
                [_vm._v("基金代码")]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticStyle: {
                display: "flex",
                flex: "7",
                "justify-content": "flex-start",
              },
            },
            [_vm._v("基金名称")]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticStyle: {
                display: "flex",
                flex: "3.5",
                "justify-content": "flex-start",
              },
            },
            [
              _c(
                "span",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "flex-start",
                    "margin-left": "5px",
                  },
                },
                [_vm._v("基金经理")]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticStyle: {
                display: "flex",
                flex: "3.8",
                "justify-content": "flex-start",
              },
            },
            [
              _c(
                "span",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "flex-start",
                    "margin-left": "10px",
                  },
                },
                [_vm._v("晨星分类")]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticStyle: {
                display: "flex",
                flex: "2.5",
                "justify-content": "flex-start",
              },
            },
            [_vm._v("最新规模(亿元)")]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticStyle: {
                display: "flex",
                flex: "1.5",
                "justify-content": "flex-end",
              },
            },
            [_vm._v("是否指数")]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticStyle: {
                display: "flex",
                flex: "2",
                "justify-content": "flex-end",
              },
            },
            [_vm._v("是否发起式")]
          ),
        ]
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "bottom2-area" }, [
      _c("span", { staticStyle: { "font-weight": "600" } }, [
        _vm._v("免责声明："),
      ]),
      _c("span", [
        _vm._v(
          "晨星（Morningstar）不保证信息的准确性、完整性和及时性，同时也不保证不会发⽣任何变更。此资料、数据、观点仅供参考，并不构成投资建议。在任何情况\n                                下，我公司不就本报告中的任何内容对任何投资⾏为做出任何形式的担保。基⾦过往业绩并不预示其未来表现，市场有⻛险，投资需谨慎。本报告内容的版权归晨星资讯（深\n                                圳）有限公司所有，未获得书⾯授权许可，不得以任何形式复制或⽤于制作报告、⽂件等⽤途。"
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }